{
 "alert.added": "Parada nueva: {name}",
 "alert.allMoved": {
  "one": "La {n} parada pasó a otro chofer: no tiene nada que entregar en esta ruta",
  "other": "Las {n} paradas pasaron a otro chofer: no tiene nada que entregar en esta ruta"
 },
 "alert.kind.cancel": "Parada cancelada",
 "alert.kind.hold": "Cuenta retenida",
 "alert.kind.money": "Pago",
 "alert.kind.new": "Parada nueva",
 "alert.kind.reopt": "Ruta reordenada",
 "alert.kind.update": "Cambio en la ruta",
 "alert.manyAdded": "{n} paradas nuevas: {names} y {more} más",
 "alert.manyRemoved": "{n} paradas quitadas: NO entregue a {names} ni a {more} más",
 "alert.removed": "Parada quitada: NO entregue a {name}",
 "alert.reordered": "Se cambió el orden de la ruta: revise su próxima parada",
 "alert.showStops": "Ver mis paradas",
 "badge.timed": "CON HORA",
 "badge.urgent": "URGENTE",
 "badge.willCall": "POR LLAMADA",
 "block.codCharge": "Contra entrega · cobre la tarjeta registrada para entregar",
 "block.codNoCard": "Contra entrega · no hay tarjeta válida registrada: cobre una tarjeta o pida autorización a la oficina",
 "block.collect": "Cobre el pago (o pida autorización a la oficina) para entregar",
 "block.hold": "RETENIDA: no entregue. Llame a su gerente de ruta",
 "block.pallets": "Escultura · escanee las {n} tarimas ({done}/{n} listas): si falta una pieza, el pedido no sirve",
 "brief.day": "Día",
 "brief.night": "Noche",
 "brief.outOf": "Sale de",
 "brief.shift": "Turno",
 "brief.stops": "Paradas",
 "brief.truck": "Camión",
 "check.brakes": "Frenos",
 "check.checkAll": "Revise los {n} puntos",
 "check.clean": "Cabina y carga limpias",
 "check.continue": "Continuar a la carga",
 "check.fuel": "Nivel de combustible",
 "check.lights": "Luces y direccionales",
 "check.locked": "La revisión del camión está bloqueada: la ruta está en curso",
 "check.oil": "Aceite y anticongelante",
 "check.passed": "Inspección aprobada — Carga",
 "check.photoNotKept": "Foto tomada, pero el teléfono no tiene espacio para guardarla — se perderá si se cierra la app",
 "check.photoOnFile": "Foto guardada",
 "check.photoThis": "Fotografiar este punto",
 "check.photographed": "Foto tomada: {item}",
 "check.progress": "{done} de {n} revisados — toque cada punto para marcarlo (tomarle una foto también lo marca)",
 "check.psi": "{tire} PSI",
 "check.reefer": "Temp. refrigerado / congelador",
 "check.safety": "Equipo de seguridad y correas",
 "check.tire.FL": "DI",
 "check.tire.FR": "DD",
 "check.tire.RL": "TI",
 "check.tire.RR": "TD",
 "check.title": "Inspección del camión · {truck}",
 "common.backWord": "Atrás",
 "common.cancel": "Cancelar",
 "common.close": "Cerrar",
 "common.decrease": "disminuir",
 "common.done": "Listo",
 "common.driver": "Chofer",
 "common.increase": "aumentar",
 "common.optional": "opcional",
 "common.signOut": "Cerrar sesión",
 "common.tryAgain": "inténtelo de nuevo",
 "common.unknown": "desconocido",
 "contact.calling": "Llamando a {name} · {phone}",
 "contact.noPhone": "No hay teléfono registrado de {name}",
 "contact.textReady": "Mensaje “a ~{n} min” listo para {name}",
 "del.amountDue": "Total a cobrar",
 "del.deliveredNow": "Entregado ahora",
 "del.deposit": "Depósito",
 "del.empties": "Envases vacíos devueltos",
 "dep.title": "Envases (depósitos)",
 "dep.back": "Devueltos (envases vacíos)",
 "dep.out": "{n} entregados",
 "dep.held": "el cliente tiene {n}",
 "dep.noCharge": "Sin cargo — no hay precio de depósito",
 "dep.each": "{money} de depósito c/u",
 "dep.left": "{n} quedan con el cliente: depósito de {money} en la factura",
 "dep.leftNc": "{n} quedan con el cliente — sin cargo, se cuentan",
 "dep.extra": "{n} devueltos de más: crédito de {money}",
 "dep.extraNc": "{n} devueltos de más — sin cargo, se cuentan",
 "dep.even": "Intercambio parejo — sin cargo de depósito",
 "dep.more": "Recoger otros envases",
 "dh.inv.empties": "Envases vacíos en el camión",
 "del.lease": "Cobrar también la renta pendiente de {money}",
 "del.palletScanned": "Tarima {n}/{of} escaneada",
 "del.resolveFirst": "Resuelva primero el bloqueo",
 "del.savedOffline": "Guardado: se enviará al volver la señal",
 "detail.collected": "Cobrado",
 "detail.customer": "Cliente",
 "detail.did": "Hizo",
 "detail.readOnly": "Registro de solo lectura.",
 "detail.readOnlySkipped": "Registro de solo lectura: atiéndala ahora si puede regresar.",
 "detail.reason": "Motivo",
 "detail.timeOnStop": "Tiempo en la parada",
 "dh.arrive.away": "Está a {dist}: es la próxima parada",
 "dh.arrive.gps": "El GPS lo ubica en la parada",
 "dh.arrive.here": "Ya llegué",
 "dh.arrive.none": "{why}: su llegada se registra cuando empiece",
 "dh.cap.aria": "Sincronización: {state}, última confirmación {time}. Abrir los detalles de sincronización.",
 "dh.cap.checking": "Revisando",
 "dh.cap.demo": "Demo",
 "dh.cap.demoAria": "Versión de demostración: no hay servidor de la oficina para sincronizar. Abrir los detalles de sincronización.",
 "dh.cap.demoSub": "sin servidor",
 "dh.cap.lastFailed": "Falló el envío",
 "dh.cap.live": "En vivo",
 "dh.cap.notLive": "No en vivo",
 "dh.cap.offline": "Sin conexión",
 "dh.cap.offlineAria": {
  "one": "Sin conexión: {n} elemento guardado en este teléfono. Abrir los detalles de sincronización.",
  "other": "Sin conexión: {n} elementos guardados en este teléfono. Abrir los detalles de sincronización."
 },
 "dh.cap.refused": {
  "one": "{n} rechazado",
  "other": "{n} rechazados"
 },
 "dh.cap.retrying": {
  "one": "{n} en reintento",
  "other": "{n} en reintento"
 },
 "dh.cap.saved": {
  "one": "{n} guardado",
  "other": "{n} guardados"
 },
 "dh.cap.sending": "Enviando…",
 "dh.cap.waiting": {
  "one": "{n} pendiente",
  "other": "{n} pendientes"
 },
 "dh.card.eta": "Llegada {time}",
 "dh.card.last": "Última visita {day} · {what}",
 "dh.card.lastUnits": "{n} {unit}",
 "dh.card.usual": "Pedido habitual",
 "dh.check.items": "Revisión · {done} de {n}",
 "dh.check.passed": "Inspección aprobada: cargar el camión",
 "dh.check.tires": "Presión de llantas",
 "dh.check.title": "Inspección previa · {truck}",
 "dh.check.toToday": "Volver a Hoy",
 "dh.chip.hold": "RETENIDA",
 "dh.chip.holdAmt": "RETENIDA {money}",
 "dh.chip.pastDue": "VENCIDA",
 "dh.chip.pastDueAmt": "VENCIDA {money}",
 "dh.done.collected": "Cobrado {money} · {method}",
 "dh.done.credit": "{money} quedó como crédito en la cuenta",
 "dh.done.creditUsed": "Crédito de la cuenta de {money} aplicado",
 "dh.done.email": "Enviar factura por correo",
 "dh.done.text": "Enviar factura por mensaje",
 "dh.done.textOk": "El cliente aceptó: enviar mensaje",
 "dh.done.texted": "Enviada a {to}",
 "dh.done.textQueued": "Se enviará al volver la señal",
 "dh.done.emailed": "Enviado",
 "dh.done.list": "Lista de paradas",
 "dh.done.local": "Guardado en este teléfono (demostración, sin oficina)",
 "dh.done.next": "Siguiente parada · {name}",
 "dh.done.notHere": "requiere la oficina",
 "dh.done.print": "Imprimir",
 "dh.done.queued": "Guardado en este teléfono: se enviará",
 "dh.done.receipt": "Recibo",
 "dh.done.refused": "La oficina no lo registró: vea Sincronización",
 "dh.done.sending": "Enviando a la oficina…",
 "dh.done.sent": "La oficina ya lo tiene",
 "dh.done.title": "Parada terminada",
 "dh.eod.confirm": "Confirmar descarga",
 "dh.eod.diff": "Dif.",
 "dh.eod.journal": "Registro de cobros",
 "dh.eod.open": {
  "one": "{n} parada sigue abierta",
  "other": "{n} paradas siguen abiertas"
 },
 "dh.eod.print": "Imprimir",
 "dh.eod.sub": "{done} hechas · {skipped} omitidas · de {of}",
 "dh.eod.unload": "Cuente lo que regresó",
 "dh.equip.none": "No hay equipo registrado en esta parada en este teléfono. El escaneo de etiquetas llega más adelante.",
 "dh.hist.delivered": "Entregado: {n}",
 "dh.hist.notHere": "El historial viene de la oficina; no está en este teléfono.",
 "dh.hist.served": "Atendida",
 "dh.hist.skipped": "Omitida",
 "dh.hist.started": "Iniciada, sin terminar",
 "dh.info.address": "Dirección",
 "dh.info.email": "Correo",
 "dh.info.order": "Pedido",
 "dh.info.phone": "Teléfono",
 "dh.info.terms": "Condiciones",
 "dh.inv.row": "{n} de {of} cargados",
 "dh.load.accept": "Aceptar artículo {n}",
 "dh.load.count": {
  "one": "Lista de carga · {n} artículo",
  "other": "Lista de carga · {n} artículos"
 },
 "dh.load.explain": "Cargue primero lo último que entregará: la app lo guía artículo por artículo. Acepte cada uno; una caja de hielo seco muestra lo que contiene.",
 "dh.load.qrAll": "QR del camión",
 "dh.load.serverLocked": "La oficina ya tiene esta ruta iniciada: {n} artículo(s) no se cambiaron y se muestran como los tiene la oficina.",
 "dh.load.start": "Empezar a cargar",
 "dh.load.submit": "Carga confirmada: iniciar ruta",
 "dh.load.tag": "Pendiente: escanee la etiqueta del equipo",
 "dh.load.title": "Carga",
 "dh.look.autoAt": "Día desde las {rise} · noche desde las {set}",
 "dh.look.autoClock": "Día de 7 a. m. a 7 p. m. hasta que el teléfono sepa dónde está",
 "dh.look.company": "Usar estilo de empresa",
 "dh.look.day": "Día",
 "dh.look.hint.flight": "Línea de tiempo",
 "dh.look.hint.grid": "Mosaicos grandes",
 "dh.look.hint.ledger": "Predeterminado",
 "dh.look.hint.nextstop": "Una tarjeta",
 "dh.look.mode.auto": "Automático",
 "dh.look.mode.day": "Siempre de día",
 "dh.look.mode.night": "Siempre de noche",
 "dh.look.night": "Noche",
 "dh.look.openStop": "Abrir parada",
 "dh.look.pinned": "Se queda así hasta que usted lo cambie",
 "dh.look.preview": "Vista previa",
 "dh.look.sampleStop": "Su próxima parada",
 "dh.look.start": "Empezar con este estilo",
 "dh.look.sub": "Puede cambiarlo cuando quiera en Más",
 "dh.look.title": "Elija su estilo",
 "dh.more.equip": "Escanear equipo",
 "dh.more.equipNotYet": "Escanear equipo: aún no disponible",
 "dh.more.faceIsOn": "El acceso con Face ID está activado: desactivar",
 "dh.more.faceOn": "Entrar con Face ID en este teléfono",
 "dh.more.inventory": "Inventario del camión",
 "dh.more.look": "Estilo",
 "dh.more.pickLook": "Diseño y colores · {layout}",
 "dh.more.qr": "QR del camión",
 "dh.more.recap": "Resumen del día anterior",
 "dh.more.signedInTo": "Sesión iniciada en {tenant}",
 "dh.more.sync": "Estado de sinc. · Sincronizar ahora",
 "dh.more.themeNow": "Ahora se ve {theme}",
 "dh.more.themeWaiting": "Los colores nuevos se aplican cuando la pantalla esté libre",
 "dh.more.today": "Su día",
 "dh.more.todayRow": "Hoy · revisiones y fin del día",
 "dh.more.transfer": "Traspaso a otro camión",
 "dh.more.truck": "Camión",
 "dh.notes.none": "Todavía no hay notas para este lugar.",
 "dh.offline.banner": {
  "one": "Sin conexión desde las {time}: {n} elemento guardado en este teléfono",
  "other": "Sin conexión desde las {time}: {n} elementos guardados en este teléfono"
 },
 "dh.or.credit": "Crédito {amount}",
 "dh.pay.checkAmount": "Monto del cheque",
 "dh.pay.checkNo": "Número de cheque",
 "dh.pay.coveredByCredit": "Terminar: pagado con crédito de la cuenta",
 "dh.pay.creditRest": "{money} queda en la cuenta",
 "dh.pay.creditUsed": "Crédito de la cuenta de {money} descontado",
 "dh.pay.del": "Borrar",
 "dh.pay.due": "A cobrar",
 "dh.pay.exact": "Exacto",
 "dh.pay.m.card": "Tarjeta",
 "dh.pay.m.cash": "Efectivo",
 "dh.pay.m.check": "Cheque",
 "dh.pay.needRef": "Ingrese el número de cheque",
 "dh.pay.noCard": "No hay tarjeta válida registrada",
 "dh.pay.override": "Terminar con el código de la oficina",
 "dh.pay.ovp.change": "Dar {money} de cambio",
 "dh.pay.ovp.credit": "Dejar {money} como crédito en la cuenta de {name}",
 "dh.pay.ovp.sub": "¿Qué pasó con los {money} de más?",
 "dh.pay.ovp.subCheck": "Un cheque nunca se cambia por efectivo: los {money} de más solo pueden quedar como crédito.",
 "dh.pay.ovp.title": "{received} recibido · {due} a cobrar",
 "dh.pay.received": "Recibido",
 "dh.pay.record": "Registrar {method} {money}",
 "dh.pay.recordPay": "Registrar {method} {money}",
 "dh.pay.title": "Cobrar {money}",
 "dh.pay.titlePay": "Cobrar · se deben {money}",
 "dh.recap.onAccount": "{money} quedó en la cuenta",
 "dh.record.arrival": "Llegada",
 "dh.record.back": "Volver a la lista de paradas",
 "dh.record.byGps": "Confirmada por GPS",
 "dh.record.byTap": "Registrada por el chofer",
 "dh.record.delivered": "Entregado",
 "dh.record.done": "Terminada",
 "dh.record.reservice": "Atender esta parada ahora",
 "dh.record.skipped": "Omitida",
 "dh.screen.endOfDay": "Fin del día",
 "dh.screen.load": "Carga",
 "dh.screen.pretrip": "Inspección previa",
 "dh.shiftNotSaved": "El teléfono no tiene espacio de almacenamiento — el progreso de hoy puede perderse si se cierra la app. Libere espacio en el teléfono.",
 "dh.skip.title": "Omitir {name}",
 "dh.cf.back": "Volver",
 "dh.cf.yes": "Confirmar",
 "dh.cf.skip.aria": "Omitir — {reason}",
 "dh.cf.close.aria": "Cerrar — {reason}",
 "dh.cf.short.title": "¿Entregar {n} de {of}?",
 "dh.cf.short.body": {
  "one": "La unidad restante vuelve a la oficina sin programar.",
  "other": "Las otras {n} unidades vuelven a la oficina sin programar."
 },
 "dh.cf.short.yes": "Entregar {n}",
 "dh.cf.short.noneTitle": "¿No entregar nada?",
 "dh.cf.short.noneBody": {
  "one": "La unidad vuelve a la oficina sin programar.",
  "other": "Las {n} unidades vuelven a la oficina sin programar."
 },
 "dh.cf.short.noneYes": "No entregar nada",
 "dh.cf.skip.sheet": "La parada vuelve a la oficina como omitida y pasa al día siguiente. Toque el motivo para omitirla.",
 "dh.cf.close.skipN": {
  "one": "{n} parada vuelve a la oficina como omitida y pasa al día siguiente.",
  "other": "{n} paradas vuelven a la oficina como omitidas y pasan al día siguiente."
 },
 "dh.cf.close.pick": "Toque el motivo para cerrarlas.",
 "dh.cf.skip.title": "¿Omitir {name}?",
 "dh.cf.close.title": {
  "one": "¿Cerrar {n} parada abierta?",
  "other": "¿Cerrar {n} paradas abiertas?"
 },
 "dh.cf.close.cancel": {
  "one": "{n} parada fuera de ruta se cancela: sale de su día.",
  "other": "{n} paradas fuera de ruta se cancelan: salen de su día."
 },
 "dh.cf.done.title": "¿Terminar su día en {route}?",
 "dh.cf.done.count": "La oficina recibe su conteo de fin de día: {back} devueltos, {damaged} dañados.",
 "dh.cf.done.body": "Su día se cierra en este teléfono y la oficina lo ve como terminado.",
 "dh.cf.done.yes": "Terminar mi día",
 "dh.cf.offEnd.title": "¿Terminar fuera de ruta?",
 "dh.cf.offEnd.body": {
  "one": "{reason}: {mins} min, {n} anotación. La oficina lo ve como terminado; si vuelve a salir de ruta, empieza uno nuevo.",
  "other": "{reason}: {mins} min, {n} anotaciones. La oficina lo ve como terminado; si vuelve a salir de ruta, empieza uno nuevo."
 },
 "dh.cf.fill0.title": "¿Terminar {name} sin entregar nada?",
 "dh.cf.fill0.body": "Esta parada no tiene productos. La oficina la verá como atendida sin nada entregado.",
 "dh.cf.fill0.yes": "Terminar sin nada",
 "dh.cf.flag.title": "¿Enviar su conteo del camión {truck}?",
 "dh.cf.flag.diff": {
  "one": "{n} artículo no coincide con lo que preparó el almacén: {list}.",
  "other": "{n} artículos no coinciden con lo que preparó el almacén: {list}."
 },
 "dh.cf.flag.same": "Su conteo coincide con lo que preparó el almacén.",
 "dh.cf.flag.body": "Su conteo pasa a ser la carga de este camión y se avisa a la oficina.",
 "dh.cf.count.title": "¿Enviar su conteo de {route}?",
 "dh.cf.count.body": {
  "one": "{units} en total en {n} producto: esto pasa a ser lo que hay en su camión y se habilita la venta.",
  "other": "{units} en total en {n} productos: esto pasa a ser lo que hay en su camión y se habilita la venta."
 },
 "dh.cf.count.zero": {
  "one": "{n} producto se cuenta como 0.",
  "other": "{n} productos se cuentan como 0."
 },
 "dh.cf.xfer.title": "¿Pasar {qty} × {item} al camión {truck}?",
 "dh.cf.xfer.body": "Sale del conteo de su camión y pasa al del camión {truck}. Solo un traspaso de vuelta lo deshace.",
 "dh.cf.signout.title": "¿Cerrar sesión en este teléfono?",
 "dh.cf.signout.unsent": {
  "one": "{n} cambio aún no llega a la oficina. Se queda en este teléfono y se envía la próxima vez que usted inicie sesión aquí (dentro de un día), nunca a nombre de otra persona.",
  "other": "{n} cambios aún no llegan a la oficina. Se quedan en este teléfono y se envían la próxima vez que usted inicie sesión aquí (dentro de un día), nunca a nombre de otra persona."
 },
 "dh.cf.signout.body": "Su ruta sale de esta pantalla hasta que vuelva a iniciar sesión.",
 "dh.cf.face.title": "¿Desactivar el inicio de sesión con Face ID / huella?",
 "dh.cf.face.body": "Este teléfono deja de ofrecerlo al iniciar sesión hasta que lo vuelva a activar aquí.",
 "dh.cf.face.yes": "Desactivarlo",
 "dh.stop.add": "Agregar",
 "dh.stop.cantSign": "El cliente no puede firmar",
 "dh.stop.collect": "Cobrar {money}",
 "dh.stop.credit": "{money} de crédito en esta cuenta: se descuenta de esta factura",
 "dh.stop.finish": "Terminar parada",
 "dh.stop.hold": "La oficina dejó a este cliente con la cuenta RETENIDA: no entregue. Llame a su gerente de ruta para saber qué hacer. Todavía puede cobrar un pago",
 "dh.stop.lease": "Renta pendiente",
 "dh.stop.misc": "Agregar de este camión",
 "dh.stop.noPayment": "Sin pago",
 "dh.stop.noPrice": "Sin precio: la oficina lo fija",
 "dh.fill.priceNeeded": "Falta precio",
 "dh.fill.needsPrice": "{n} sin precio",
 "dh.fill.officePrices": "la oficina les fija el precio",
 "dh.stop.notNext": "No es su próxima parada: si la atiende, pasa a ser la siguiente",
 "dh.stop.officeChanged": "La oficina cambió este pedido · {time}",
 "dh.stop.officeNote": "Nota de la oficina: {notes}",
 "dh.stop.ofOrdered": "de {n} {unit} en el pedido",
 "dh.stop.pastDue": "Saldo vencido de {money} en esta cuenta: pídalo",
 "dh.stop.payOnly": "Solo cobrar",
 "dh.stop.photo": "Foto de la entrega",
 "dh.stop.photosN": {
  "one": "{n} foto",
  "other": "{n} fotos"
 },
 "dh.stop.redo": "Repetir",
 "dh.stop.required": "Obligatoria",
 "dh.stop.scanPallet": "Escanear tarima {n}",
 "dh.stop.sign": "Firma",
 "dh.stop.signFirst": "Primero obtenga la firma (o indique por qué no la hay)",
 "dh.stop.signNow": "Firmar",
 "dh.stop.signedBy": "Firmado · {name}",
 "dh.stop.takeIfOffered": "Cobrar",
 "dh.stop.takePhoto": "Foto",
 "dh.stop.thisStop": "Esta parada",
 "dh.stop.total": "Total",
 "dh.routing.nowLocked": "Ahora la oficina fija el orden de sus paradas: no puede reordenarlas.",
 "dh.routing.nowAuto": "Puede reordenar sus paradas; un orden nuevo de la oficina reemplaza el suyo de inmediato.",
 "dh.routing.nowChoose": "Puede reordenar sus paradas; cuando la oficina envíe un orden nuevo, usted elige: usarlo o mantener el suyo.",
 "dh.routing.officeOrder": "Orden de la oficina",
 "dh.routing.officeOrderSub": "Su empresa fija el orden de las paradas",
 "dh.routing.yourOrder": "Su orden de paradas",
 "dh.routing.subAuto": "Un orden nuevo de la oficina se aplica de inmediato",
 "dh.routing.subChoose": "Un orden nuevo de la oficina le pregunta primero",
 "dh.routing.reorder": "Reordenar",
 "dh.routing.optimize": "Optimizar desde aquí",
 "dh.routing.needsConnection": "Necesita conexión",
 "dh.routing.needsTwo": "Necesita dos paradas pendientes",
 "dh.routing.lockedNoMove": "Su empresa fija el orden de las paradas: esta parada mantiene su lugar.",
 "dh.routing.reoTitle": "Reordene sus paradas",
 "dh.routing.reoSub": "Mueva las paradas pendientes. Las paradas ya atendidas mantienen su lugar.",
 "dh.routing.served": "{n} atendidas: mantienen su lugar",
 "dh.routing.up": "Subir {name}",
 "dh.routing.down": "Bajar {name}",
 "dh.routing.moved": "movida",
 "dh.routing.save": "Guardar orden",
 "dh.routing.undo": "Deshacer",
 "dh.routing.saved": "Orden de paradas guardado: la oficina lo ve.",
 "dh.routing.savedQueued": "Orden de paradas guardado en este teléfono: llega a la oficina cuando tenga señal.",
 "dh.routing.optLoading": "Calculando un mejor orden desde aquí…",
 "dh.routing.savesMi": "ahorra ~{n} mi",
 "dh.routing.savesMin": "~{n} min menos",
 "dh.routing.straight": "(≈ en línea recta)",
 "dh.routing.optNoChange": "Su orden ya es el mejor desde aquí.",
 "dh.routing.optNoSaving": "No se calculó un ahorro para este orden.",
 "dh.routing.optFailed": "No se pudo calcular un orden: inténtelo de nuevo.",
 "dh.routing.apply": "Usar este orden",
 "dh.routing.pendingBanner": "La oficina envió un orden nuevo de paradas · enviado por {who}",
 "dh.routing.pendingTitle": "Orden nuevo de paradas de la oficina",
 "dh.routing.from": "Enviado por {who}",
 "dh.routing.useNew": "Usar el orden nuevo",
 "dh.routing.keepMine": "Mantener mi orden",
 "dh.routing.newOrder": "Orden nuevo",
 "dh.routing.yourNow": "Su orden actual",
 "dh.routing.usedNew": "Usando el orden nuevo.",
 "dh.routing.keptMine": "Se mantiene su orden: se avisó a la oficina.",
 "dh.routing.decQueued": "Su respuesta está guardada en este teléfono: llega a la oficina cuando tenga señal.",
 "dh.routing.remind": "El orden nuevo de paradas de la oficina todavía espera su respuesta.",
 "dh.routing.officeUpdated": "La oficina actualizó el orden de la ruta",
 "dh.routing.review": "Revisar",
 "dh.routing.src.monitor": "el agente monitor",
 "dh.routing.src.nightly": "el plan nocturno",
 "dh.routing.src.optimizer": "el optimizador de rutas",
 "dh.routing.src.office": "la oficina",
 "dh.stops.allDone": "Todas las paradas están cerradas: {done} hechas, {skipped} omitidas, {money} cobrado. Sigue el fin del día.",
 "dh.stops.call": "Llamar",
 "dh.stops.done": "Hechas",
 "dh.stops.doneSkipped": "{done} hechas · {skipped} omitidas",
 "dh.stops.history": "Historial",
 "dh.stops.navigate": "Navegar",
 "dh.stops.navigateTo": "Navegar a la parada",
 "dh.stops.next": "Siguiente",
 "dh.stops.noneDone": "Todavía no hay paradas hechas.",
 "dh.stops.noneSkipped": "No hay paradas omitidas.",
 "dh.stops.open": "Abrir {name}",
 "dh.stops.remaining": "Pendientes",
 "dh.stops.routeUpdated": "Ruta reordenada: toque cuando esté detenido para ver el nuevo orden",
 "dh.stops.skip": "Omitir",
 "dh.stops.skipped": "Omitidas",
 "dh.stops.stopNofM": "Parada {n} de {of}",
 "dh.stops.textEta": "Avisar llegada",
 "dh.stops.thenN": {
  "one": "Después · {n} más",
  "other": "Después · {n} más"
 },
 "dh.sync.attentionN": "Requiere atención · {n}",
 "dh.sync.backingOff": "Se intentará de nuevo",
 "dh.sync.count": "Cant.",
 "dh.sync.lastOffline": "Última vez sin conexión: {from} – {to}",
 "dh.sync.moneyKept": "Se guarda en este teléfono. Los cobros no se pueden borrar aquí.",
 "dh.sync.oldest": "Más antiguo",
 "dh.sync.refused": "Rechazado",
 "dh.sync.title": "Sincronización",
 "dh.sync.toldAt": "Ya se avisó a la oficina · {time}",
 "dh.tab.deliver": "Entregar",
 "dh.tab.equip": "Equipo",
 "dh.tab.history": "Historial",
 "dh.tab.info": "Datos",
 "dh.tab.notes": "Notas",
 "dh.today.afterLast": "Después de la última parada",
 "dh.today.ahead": "Vista previa · {day}",
 "dh.today.aheadNote": "Solo lectura: no se puede hacer nada en un día futuro.",
 "dh.today.dateLine": "{day} · {name}",
 "dh.today.done": "Hecho",
 "dh.today.endOfDay": "Fin del día",
 "dh.today.first": "Primera",
 "dh.today.gates": "Antes de salir",
 "dh.today.load": "Cargar el camión",
 "dh.today.loadLabel": "Carga",
 "dh.today.loadTruck": "Cargar el camión",
 "dh.today.locked": "Hecho · bloqueado",
 "dh.today.notYet": "Pendiente",
 "dh.today.orders": {
  "one": "{n} pedido",
  "other": "{n} pedidos"
 },
 "dh.today.pretrip": "Inspección previa al viaje",
 "dh.today.progress": "{done} hechas · {skipped} omitidas · de {of}",
 "dh.today.ready": "Listo",
 "dh.today.routeStops": {
  "one": "{n} parada de ruta",
  "other": "{n} paradas de ruta"
 },
 "dh.today.seeEndOfDay": "Ver fin del día",
 "dh.today.startPretrip": "Iniciar inspección previa",
 "dh.today.startRoute": "Iniciar ruta",
 "dh.today.stopList": {
  "one": "Lista de paradas · {n} parada",
  "other": "Lista de paradas · {n} paradas"
 },
 "dh.today.toStops": "Volver a mis paradas",
 "dh.today.units": "{n} {unit}",
 "dh.today.watchN": "Para vigilar · {n}",
 "dh.today.watchNone": "No hay cuentas retenidas ni vencidas en la ruta de hoy.",
 "dh.today.willCall": {
  "one": "{n} por llamada",
  "other": "{n} por llamada"
 },
 "dh.view.list": "Lista",
 "dh.view.map": "Mapa",
 "dh.xfer.confirm": "Confirmar traspaso",
 "dh.xfer.record": "Registrar traspaso",
 "dh.xfer.title": "Traspaso a otro camión",
 "display.company": "Empresa ({value})",
 "display.dayTheme": "Colores de día",
 "display.layout": "Diseño",
 "display.layout.flight": "Flight deck",
 "display.layout.grid": "Cuadrícula para guantes",
 "display.layout.ledger": "Ledger",
 "display.layout.nextstop": "Próxima parada primero",
 "display.mode.auto": "Automático por el sol",
 "display.mode.day": "Día",
 "display.mode.night": "Noche",
 "display.nightTheme": "Colores de noche",
 "display.theme.flight-dark": "Flight deck oscuro",
 "display.theme.flight-light": "Flight deck claro",
 "display.theme.iris-dark": "Iris oscuro",
 "display.theme.iris-light": "Iris claro",
 "display.theme.ledger-dark": "Ledger oscuro",
 "display.theme.ledger-light": "Ledger claro",
 "display.theme.navy-dark": "Navy oscuro",
 "display.theme.navy-light": "Navy claro",
 "display.theme.slate-dark": "Slate oscuro",
 "display.theme.slate-light": "Slate claro",
 "display.themeMode": "Tema",
 "eod.card": "Cobrado con tarjeta",
 "eod.cash": "Efectivo / cheque / giro",
 "eod.credits": "Créditos aplicados",
 "eod.delivered": "Entregado",
 "eod.left": "Queda",
 "eod.noteDelivered": "Entregado:",
 "eod.noteOut": "Salió:",
 "eod.noteOutCounted": "la carga que contó en el andén.",
 "eod.noteOutNone": "no se contó la carga, así que no se muestra.",
 "eod.noteReturned": "Devuelto y restante: todavía no se registran; cuéntelos en el andén. Nada aquí es estimado.",
 "eod.noteServed": "sus paradas atendidas y las líneas de sus pedidos.",
 "eod.noteUnattributed": {
  "one": "{n} parada atendida no tiene líneas de producto, así que no se muestra por producto.",
  "other": "{n} paradas atendidas no tienen líneas de producto, así que no se muestran por producto."
 },
 "eod.nothing": "Hoy no hay nada registrado en este camión.",
 "eod.out": "Salió",
 "eod.product": "Producto",
 "eod.ret": "Dev.",
 "eod.returned": "Devuelto",
 "eod.sold": "Vendido",
 "eod.total": "Total cobrado",
 "eod.varDemoTitle": "Diferencia · salida / devolución / venta",
 "eod.varLiveTitle": "Diferencia · salida / entrega / devolución",
 "equip.notYet": "El escaneo de equipo todavía no está disponible: nada llegaría a la oficina",
 "eta.early": "temprano",
 "eta.late": "tarde",
 "eta.ontime": "a tiempo",
 "flow.alreadyCollected": "Ya cobrado",
 "flow.callOffice": "llame a la oficina",
 "flow.checkingLocation": "Revisando su ubicación…",
 "flow.customer": "cliente",
 "flow.did.exchange": "Equipo cambiado",
 "flow.did.install": "Equipo instalado",
 "flow.did.return": "Equipo retirado",
 "flow.did.service": "Se dio servicio al equipo",
 "flow.didDeliver": "Entrega: {n}/{of} {unit} · {money}",
 "flow.eqNotScannedShort": "sin escanear",
 "flow.eqSub": "El escaneo de etiquetas todavía no está disponible en la app. Haga el trabajo y continúe: la parada queda registrada como no escaneada.",
 "flow.namePh": "nombre",
 "flow.noFix": "Sin ubicación GPS",
 "flow.noSignature": "Sin firma · {why}",
 "flow.notTimed": "No se cuenta el tiempo hasta que llegue. Toque abajo si ya está en el lugar.",
 "flow.overrideIfShort": "Autorización de la oficina (si falta)",
 "flow.printed": "impreso",
 "flow.reason.deliver": "Entregar pedido",
 "flow.reason.exchange": "Cambio de equipo",
 "flow.reason.install": "Instalar equipo",
 "flow.reason.return": "Retirar equipo",
 "flow.reason.service": "Dar servicio al equipo",
 "flow.receivedBy": "Recibido por",
 "flow.releaseCode": "Código de liberación",
 "flow.scannedOf": "{done}/{n} escaneadas",
 "flow.shortNote": "Si entrega menos, el resto pasa automáticamente a Sin programar.",
 "gps.mAway": "a {n} m",
 "gps.miAway": "a {n} mi",
 "gps.why.blocked": "la ubicación está bloqueada",
 "gps.why.looking": "todavía buscando",
 "gps.why.noLocation": "este teléfono no tiene ubicación",
 "gps.why.noSignal": "sin señal",
 "gps.why.rough": "la ubicación es demasiado imprecisa",
 "hist.accessNotes": "notas de acceso",
 "hist.back": "Volver a la parada",
 "hist.banner": "Este lugar tiene historial",
 "hist.bannerSub": "{bits}: toque para leer",
 "hist.deliveredOf": "Entregado: {n} de {of} en el pedido",
 "hist.footer": "Lo anotó quien atendió este lugar antes: se queda con el lugar, no con la ruta.",
 "hist.gettingIn": "Cómo entrar",
 "hist.loadFailed": "No se pudo cargar el historial de este lugar",
 "hist.loading": "Cargando el historial de este lugar…",
 "hist.noDriver": "chofer no registrado",
 "hist.none": "No hay visitas anteriores registradas.",
 "hist.photos": {
  "one": "{n} foto guardada de esa visita · se ve en la oficina",
  "other": "{n} fotos guardadas de esa visita · se ven en la oficina"
 },
 "hist.picked": "Recogido: {n}",
 "hist.prevVisits": {
  "one": "{n} visita anterior",
  "other": "{n} visitas anteriores"
 },
 "hist.served": "Atendida",
 "hist.thisSite": "Este lugar",
 "hist.title": "{site}: historial",
 "hist.you": "(usted)",
 "home.moreTitle": "Tema, idioma, acceso",
 "home.nextDay": "Día siguiente",
 "home.noRoutes": "No hay rutas que manejar",
 "home.noRoutesHint": "El recorrido del chofer aparece aquí cuando las rutas están creadas (Rutas) y despachadas (Tablero).",
 "home.prevDay": "Día anterior",
 "home.switchRoute": "Cambiar de ruta",
 "imp.banner": "SUPLANTANDO A {name}",
 "imp.by": "por {name}",
 "imp.exit": "Salir",
 "inv.explain": "Disponible ahora (lo cargado menos lo entregado hasta ahora).",
 "inv.none": "Este camión no tiene carga.",
 "item.added": "Agregado a pedido del cliente: {qty}× {item}",
 "lc.addLabel": "Agregar un producto fuera del plan",
 "lc.addOption": "Agregar un producto fuera del plan…",
 "lc.emptyBack": "Volver",
 "lc.emptyBody": "No hay nada registrado a bordo de {route}: todas las líneas están en 0. Confirme solo si el camión realmente sale vacío.",
 "lc.emptyGo": "Confirmar carga vacía",
 "lc.emptyTitle": "¿Confirmar una carga vacía?",
 "lc.extra": "extra · fuera del plan",
 "lc.extraN": "+{n} de más",
 "lc.less": "Uno menos de {item}",
 "lc.line": "{loaded} cargados · plan {plan}",
 "lc.loaded": "Cargado: {item}",
 "lc.more": "Uno más de {item}",
 "lc.plan": "plan {n}",
 "lc.shortN": "faltan {n}",
 "lc.sub": "empiece con el plan; cámbielo a lo que realmente cargó",
 "lc.title": "Cuente lo que va en el camión",
 "load.allConfirmed": {
  "one": "{n} artículo escaneado y confirmado en orden.",
  "other": "Los {n} artículos escaneados y confirmados en orden."
 },
 "load.alreadyBound": "Ya asignado · {tag}",
 "load.binSub": {
  "one": "{n} entrega adentro · caja de hielo seco (etiquetar al cargar)",
  "other": "{n} entregas adentro · caja de hielo seco (etiquetar al cargar)"
 },
 "load.equipment": "equipo",
 "load.filoNext": "Cargue en orden FILO: sigue el artículo {n}",
 "load.freezerSub": "{reason} · equipo (etiquetar al cargar)",
 "load.itemLoaded": "Cargado: {item}",
 "load.loadNext": "Cargue esto a continuación (orden FILO): escanee para aceptar.",
 "load.locked": "La carga está bloqueada: la ruta está en curso",
 "load.nothing": "No hay nada que cargar en esta ruta.",
 "load.palletSub": "{qty} {unit} · tarima de producto",
 "load.progress": "{done}/{of} cargados",
 "load.qrNote": "¿El cargador ya lo cargó? Un escaneo del QR verifica todo el camión (responsable: el cargador).",
 "load.startRoute": "Iniciar ruta",
 "login.callOffice": "Llamar a la oficina",
 "login.driverId": "ID de chofer",
 "login.emailOrId": "Correo o ID de chofer",
 "login.emailOrIdPh": "nombre@empresa.com",
 "login.enterBoth": "Ingrese su ID de chofer y su contraseña.",
 "login.enterEmailOrId": "Ingrese su correo (o ID de chofer) y su contraseña.",
 "login.faceEnableFailed": "No se pudo activar Face ID en este teléfono. Motivo: {why}. Su contraseña sigue funcionando. Toque para cerrar.",
 "login.faceEnabled": "Acceso con Face ID activado en este teléfono",
 "login.faceFailed": "Face ID no funcionó. Use su contraseña.",
 "login.faceUnlock": "Desbloquear con Face ID / huella",
 "login.faceWaiting": "Esperando Face ID…",
 "login.help": "Su despachador se los da. Si los perdió, llame a la oficina: se lo pueden restablecer mientras espera.",
 "login.helpCall": "Su despachador se los da. ¿No puede entrar? {link}: se lo pueden restablecer mientras espera.",
 "login.noReach": "No se pudo comunicar con la oficina. Revise la señal e inténtelo de nuevo.",
 "login.password": "Contraseña",
 "login.signIn": "Entrar",
 "login.signingIn": "Entrando…",
 "login.a2hs.title": "En iPhone o iPad: primero agregue esta app a la pantalla de inicio y luego entre desde su ícono.",
 "login.a2hs.s1": "Toque ⋯ abajo en Safari (o el botón Compartir) y luego Compartir.",
 "login.a2hs.s2": "Toque Agregar a pantalla de inicio y luego Agregar.",
 "login.a2hs.s3": "Abra el nuevo ícono Chofer y entre ahí. La sesión queda abierta.",
 "login.title": "Acceso de chofer",
 "login.userPh": "p. ej. marco.ruiz",
 "login.wrong": "Usuario o contraseña incorrectos.",
 "money.cardNotRecorded": "El pago con tarjeta de {money} en {name} NO quedó registrado: la tarjeta solo se cobra con el enlace de pago o el código QR. Envíe el enlace al cliente o arréglelo con la oficina.",
 "money.creditTookPart": "El crédito de {credit} de la cuenta de {name} pagó parte de esta factura: {money} que usted cobró no quedó registrado. Devuélvalo o llame a la oficina para dejarlo como crédito.",
 "money.notRecorded": "{money} NO quedó registrado en {name}: {why}. Devuélvalo al cliente o arréglelo con la oficina.",
 "money.stillOwed": "{name} todavía debe {money} en esta factura: el crédito de la cuenta ya se usó. Cóbrelo o déjelo en la cuenta.",
 "money.whyAlreadyPaid": "esta parada ya estaba pagada",
 "money.whyAlreadyPaidAmt": "esta parada ya estaba pagada ({paid})",
 "money.whyOverBalance": "es más de lo que costó esta entrega",
 "money.whyOverBalancePaid": "es más de lo que costó esta entrega (ya se habían pagado {paid})",
 "money.whyUnpricedCap": "este pedido no tiene precio y ese monto supera el límite que se puede recibir a cuenta de él",
 "more.faceOff": "Acceso con Face ID desactivado en este teléfono",
 "more.language": "Idioma",
 "more.title": "Ajustes de la app",
 "noroute.checkAgain": "Revisar otra vez",
 "noroute.explain": "Todavía no tiene nada asignado. Toque Revisar otra vez cuando despacho haya planificado el día, o use Fuera de ruta si está trabajando de todos modos.",
 "noroute.offRoute": "Fuera de ruta",
 "noroute.recap": "Resumen",
 "noroute.signOutTitle": "Cerrar sesión en la app del chofer",
 "noroute.spotCheck": "Revisión rápida",
 "noroute.title": "Hoy no tiene ruta",
 "notice.added": {
  "one": "{n} parada nueva · {names}",
  "other": "{n} paradas nuevas · {names}"
 },
 "notice.by": "por {by}",
 "notice.byAt": "por {by} a las {time}",
 "notice.cancelled": "Cancelada",
 "notice.skipped": "Omitida",
 "notice.theOffice": "la oficina",
 "offroute.badge": "FUERA DE RUTA",
 "offroute.end": "Terminar fuera de ruta",
 "offroute.explain": "Avise a la oficina qué está haciendo. Aparece en su registro con la hora, así el día queda anotado.",
 "offroute.logAdd": "Agregar al registro",
 "offroute.logBtn": "Anotar lo que hizo",
 "offroute.logExplain": "Cada línea queda con la hora en que se escribió.",
 "offroute.logPh": "p. ej. Dejé 40 bolsas en Bay Shore Marina para RT-4",
 "offroute.logTitle": "Anotar lo que hizo",
 "offroute.notePh": "Algo que quiera agregar (opcional)",
 "offroute.nothingYet": "Todavía no hay nada anotado.",
 "offroute.queued": "guardado: se envía al volver la señal",
 "offroute.reason.cover": "Cubriendo otra ruta",
 "offroute.reason.equipment": "Entrega de equipo",
 "offroute.reason.other": "Otro",
 "offroute.reason.shop": "Taller / mantenimiento",
 "offroute.reason.training": "Capacitación",
 "offroute.reason.warehouse": "Trabajo en almacén",
 "offroute.reason.willcall": "Entrega por llamada",
 "offroute.since": "Desde {time} · {elapsed}",
 "offroute.start": "Empezar fuera de ruta",
 "offroute.tapAgain": "Toque otra vez para terminar",
 "offroute.title": "Salir de la ruta",
 "past.cancellations": "Cancelaciones",
 "past.delivered": "Entregadas",
 "past.none": "No hay historial de este día.",
 "past.ontime": "A tiempo",
 "past.outcome": "Resultado",
 "past.rolled": "Pasadas a otro día",
 "past.title": "{day} · historial del turno",
 "pay.cardNotYet": "Los pagos con tarjeta todavía no están disponibles en la app: cobre en efectivo o cheque, o la oficina puede cobrar la tarjeta registrada.",
 "pay.cardPrototype": "Solo demostración: no se mueve dinero. Los pagos con tarjeta llegan con el QR / enlace de pago.",
 "pay.charge": "Cobrar {money} a •{last4}",
 "pay.charged": "Cobrado {money}",
 "pay.chargedPrototype": "Tarjeta “cobrada”: solo demostración, no se movió dinero",
 "pay.collectedDemo": "Pago de {money} cobrado (demostración: sin registro en la oficina)",
 "pay.enterAmount": "Ingrese el monto que cobró",
 "pay.m.card": "Tarjeta",
 "pay.m.cardonfile": "Tarjeta registrada",
 "pay.m.cash": "Efectivo",
 "pay.m.check": "Cheque",
 "pay.m.moneyorder": "Giro",
 "pay.moreThanLeft": "Es más de los {money} que faltan en esta parada",
 "pay.recordedInvoice": "{money} en {method} registrado en la factura",
 "pay.recordedLater": "{money} en {method} registrado: se aplica a la factura al entregar",
 "pay.savedHere": "{money} guardado en este teléfono: la oficina lo verá cuando se pueda",
 "pay.saving": "Guardando {money} en {method}…",
 "pay.termsUnknownShort": "Condiciones: no están en el teléfono",
 "pay.title": "Cobrar",
 "pay.toCredit": "+{money} — crédito a la cuenta",
 "photo.notSaved": "La foto no se guardó: {why}",
 "photo.onPhone": "Foto tomada: queda en este teléfono (demostración, sin oficina)",
 "photo.saved": "Foto guardada",
 "photo.savedOffline": "Foto guardada: se enviará al volver la señal",
 "photo.unreadable": "No se pudo leer esa foto. Tómela de nuevo; si sigue pasando, elija una foto más pequeña o, en un iPhone, ponga Ajustes > Cámara > Formatos en Más compatible",
 "print.allowPopups": "Permita ventanas emergentes para imprimir el recibo",
 "print.opened": "Se abrió el cuadro de impresión: el recibo se imprime en inglés",
 "qr.aim": "Apunte a la etiqueta QR del camión",
 "qr.assets": "Equipos",
 "qr.assetsVal": "{n} (congeladores / cajas de hielo seco)",
 "qr.explain": "Un escaneo muestra el manifiesto de hoy de este camión, sin subir a escanear cada artículo.",
 "qr.itemByItem": "Cargar artículo por artículo (FILO)",
 "qr.manifestSub": "{day} · {driver} · ruta {route}",
 "qr.manifestTitle": "{truck} · manifiesto de hoy",
 "qr.mileage": "Rendimiento estimado",
 "qr.mpgUnit": "mpg",
 "qr.noCamera": "Cámara no disponible: toque Simular escaneo",
 "qr.noTruck": "Este chofer no tiene camión asignado",
 "qr.products": "PRODUCTOS",
 "qr.simulate": "Simular escaneo",
 "qr.title": "Escanear QR del camión",
 "qr.truckVerified": "{truck} verificado · manifiesto del {day}",
 "qr.verifiedAll": {
  "one": "QR del camión escaneado: {n} artículo verificado de una vez · responsable: el cargador",
  "other": "QR del camión escaneado: {n} artículos verificados de una vez · responsable: el cargador"
 },
 "qr.verifyAll": "Verificar toda la carga — contar y confirmar",
 "receipt.needsOffice": "Para enviar la factura por correo se necesita la conexión con la oficina y una parada real.",
 "receipt.sending": "Enviando la factura…",
 "receipt.sent": "Factura {number} enviada a {to}",
 "receipt.why.failed": "No se envió: el correo no salió. Imprima el recibo o la oficina puede reenviarlo.",
 "receipt.why.noEmail": "No se envió: este cliente no tiene correo registrado. Imprima el recibo.",
 "receipt.why.notInvoiced": "No se envió: la oficina todavía no tiene la factura de esta parada. Envíela desde la parada terminada cuando se sincronice.",
 "receipt.why.notYours": "No se envió: esa parada no está en su ruta.",
 "receipt.why.offline": "No se envió: no hay señal. Envíela desde la parada terminada cuando vuelva la conexión.",
 "receipt.textAsk": "Pregunte al cliente si acepta un mensaje y toque otra vez",
 "receipt.textAskOffline": "Sin señal: pregunte al cliente si acepta un mensaje y toque otra vez; se enviará al volver la conexión",
 "receipt.why.other": "No se envió: {why}",
 "receipt.why.tooMany": "No se envió: esta factura ya se envió 3 veces hoy. La oficina puede reenviarla.",
 "receipt.why.tooManyFailures": "No se envió: el envío de esta factura falló demasiadas veces hoy. Imprima el recibo; la oficina puede reenviarla.",
 "receipt.why.unavailable": "No se envió: el envío de facturas por correo todavía no está disponible. Imprima el recibo.",
 "reopt.needsBackend": "Reoptimizar requiere el servidor",
 "run.drivingNote": "Manejando: controles reducidos por seguridad. Abra la lista completa cuando esté detenido.",
 "run.lastStop": "Esta es su última parada.",
 "run.nextStopOf": "PRÓXIMA PARADA · {n} de {of}",
 "run.reasonReservice": "{reason} · toque para volver a atender",
 "run.rolledIn": "salió en {time}",
 "run.skippedWord": "omitida",
 "run.started": {
  "one": "{truck} en ruta · {n} parada",
  "other": "{truck} en ruta · {n} paradas"
 },
 "run.tapToView": "toque para ver",
 "run.window": "Horario",
 "sign.ask": "Pídale que firme en el recuadro.",
 "sign.clear": "Borrar",
 "sign.empty": "Todavía no hay firma",
 "sign.notSaved": "La firma no se guardó: {why}",
 "sign.onPhone": "Firma tomada: queda en este teléfono (demostración, sin oficina)",
 "sign.save": "Guardar firma",
 "sign.saved": "Firma guardada",
 "sign.savedOffline": "Firma guardada: se enviará al volver la señal",
 "sign.title": "Firma del cliente",
 "skip.back": "{name} de vuelta en la ruta",
 "skip.done": "Omitida {name} · {reason}",
 "skip.officeDefined": "Los motivos para omitir los define la oficina.",
 "skip.r.closed": "Cliente cerrado",
 "skip.r.noAccess": "Sin acceso",
 "skip.r.refused": "Rechazó la entrega",
 "srv.already_paid": "Ya está pagado por completo ({paid} cobrado).",
 "srv.amount_invalid": "Los montos van en centavos: como máximo dos decimales.",
 "srv.amount_required": "Ingrese el monto que cobró.",
 "srv.amount_say": "Indique cuánto.",
 "srv.amount_say_or_invoices": "Indique cuánto, o para qué facturas es.",
 "srv.amount_too_large_link": "Ese monto es demasiado grande para un enlace de pago.",
 "srv.arrival_time_required": "El teléfono no indicó a qué hora llegó.",
 "srv.bad_email": "Esa no es una dirección de correo.",
 "srv.bad_phone": "A ese número no se le pueden enviar mensajes de texto.",
 "srv.card_expired": "Esa tarjeta está vencida.",
 "srv.card_needs_link": "La tarjeta se cobra con el enlace de pago o el código QR, nunca se ingresa a mano.",
 "srv.card_not_on_file": "Esa tarjeta no está registrada para este cliente.",
 "srv.card_refused": "No se pudo cobrar la tarjeta.",
 "srv.cards_not_set_up": "Los pagos con tarjeta no están configurados en esta empresa: llame a la oficina.",
 "srv.cash_tally_invalid": "El total de efectivo no es válido.",
 "srv.check_number_required": "Ingrese el número de cheque.",
 "srv.client_id_required": "El teléfono no envió el identificador de la solicitud: actualice la app e intente de nuevo.",
 "srv.contact_refused": "No se guardó el contacto.",
 "srv.contact_required": "Ingrese un número de teléfono móvil o un correo.",
 "srv.count_negative": "El conteo de '{product}' no puede ser negativo.",
 "srv.customer_gone": "No se encontró el cliente.",
 "srv.damage_reason_required": "Indique por qué se dañó el producto {product}.",
 "srv.day_closed": "Este día está cerrado: su conteo ya no puede cambiar.",
 "srv.device_id_invalid": "Falta el identificador de este teléfono o no es válido.",
 "srv.device_register_failed": "No se pudo registrar este teléfono.",
 "srv.display_invalid": "Ese diseño o tema no está disponible.",
 "srv.door_items_off": "La configuración de seguridad de su empresa no permite agregar artículos en la puerta: llame a despacho para cambiar este pedido.",
 "srv.driver_gone": "No se encontró su registro de chofer: llame a la oficina.",
 "srv.email_not_set_up": "El correo no está configurado en este servidor.",
 "srv.generic": "El servidor no aceptó este cambio.",
 "srv.image_too_large": "La imagen es demasiado grande: debería reducirse en el teléfono antes de subirla.",
 "srv.invoice_choose": "Indique qué factura se va a pagar.",
 "srv.invoice_no_payment": "Esa factura no puede recibir un pago.",
 "srv.invoice_not_customers": "Esa factura no es de este cliente.",
 "srv.invoice_not_raised": "La factura todavía no se ha hecho.",
 "srv.invoice_unavailable": "La factura no está disponible.",
 "srv.invoice_needs_price": "Esta factura espera que la oficina le fije el precio: se podrá enviar cuando lo tenga.",
 "srv.load_ticks_invalid": "No se pudo leer la lista de carga.",
 "srv.no_phone": "No hay teléfono registrado para este cliente: envíe la factura por correo o imprima el recibo.",
 "srv.order_locked": "Su empresa fija el orden de las paradas: no puede reordenarlas.",
 "srv.order_invalid": "Ese orden no coincide con sus paradas: actualice su ruta e inténtelo de nuevo.",
 "srv.order_outdated": "Se envió un orden más nuevo: su teléfono ya lo muestra.",
 "srv.overpay_invalid": "Diga si lo de más se devolvió como cambio o quedó como crédito.",
 "srv.version_gone": "Ese orden no es para su ruta de hoy.",
 "srv.decision_invalid": "Elija usar o mantener.",
 "srv.no_route": "Hoy no tiene ruta.",
 "srv.nexus_off": "Nexus no forma parte del plan de esta empresa.",
 "srv.not_invoiced": "La oficina todavía no tiene la factura de esta parada: se crea cuando la entrega llega a la oficina.",
 "srv.text_send_failed": "El mensaje no se envió: envíe la factura por correo o imprima el recibo.",
 "srv.language_not_offered": "Su empresa no ofrece ese idioma.",
 "srv.language_required": "Elija un idioma.",
 "srv.link_send_failed": "No se envió el enlace.",
 "srv.load_count_invalid": "El conteo de la carga no es válido.",
 "srv.load_counted_twice": "'{product}' está contado dos veces.",
 "srv.load_data_invalid": "No se pudo leer el conteo de la carga.",
 "srv.load_field_too_big": "El conteo de '{product}' es demasiado grande para un camión.",
 "srv.load_field_whole": "El conteo de '{product}' debe ser un número entero.",
 "srv.load_from_no_lines": "Su carga no tiene líneas contadas de donde pasar.",
 "srv.load_line_no_product": "Una línea contada no tiene producto.",
 "srv.load_no_count": "'{product}' no tiene conteo.",
 "srv.load_not_counted": "Hoy no se contó su carga, así que no hay nada registrado que pasar.",
 "srv.load_phase_invalid": "Debe ser una carga o una descarga.",
 "srv.load_short": "Solo tiene {have} de {product} a bordo.",
 "srv.load_to_no_lines": "La carga del camión que recibe no tiene líneas contadas.",
 "srv.method_invalid": "La forma de pago debe ser efectivo, cheque o giro.",
 "srv.mo_number_required": "Ingrese el número del giro.",
 "srv.no_contact": "No hay contacto registrado: muestre el código QR.",
 "srv.no_invoice": "Esta parada no tiene factura.",
 "srv.no_order_add": "Esta parada no tiene un pedido al que agregar.",
 "srv.fill_lines_invalid": "Una línea entregada no es válida: revise las cantidades.",
 "srv.no_order_choose_invoice": "Esta parada no tiene pedido: elija la factura que se va a pagar.",
 "srv.no_order_payment": "Esta parada no tiene un pedido para cobrar.",
 "srv.no_truck": "No hay un camión #{truck}.",
 "srv.not_available": "No disponible.",
 "srv.not_on_route": "Esa parada no está en su ruta.",
 "srv.not_pending": "Solo se puede adelantar una parada pendiente.",
 "srv.nothing_owed": "No se debe nada de eso.",
 "srv.offroute_event_invalid": "Fuera de ruta necesita un inicio, una nota o un fin.",
 "srv.offroute_reason_required": "Se necesita un motivo para salir fuera de ruta.",
 "srv.oldest_first_rule": "Aquí los pagos van primero a la factura abierta más antigua. Para pagar una factura en particular se necesita el permiso de la oficina.",
 "srv.order_closed": "Este pedido está cerrado: ya no se le puede agregar nada.",
 "srv.order_gone": "El pedido de esa parada ya no existe.",
 "srv.over_balance": "El monto es mayor que el saldo de {balance}.",
 "srv.own_truck": "Ese es su propio camión.",
 "srv.passkey_not_set_up": "El acceso con Face ID o huella no está configurado.",
 "srv.password_change_required": "Elija una contraseña nueva antes de continuar.",
 "srv.password_change_unavailable": "Pida a la oficina que restablezca su contraseña.",
 "srv.password_changed_sign_in": "Contraseña cambiada: vuelva a entrar con ella.",
 "srv.password_current_wrong": "Su contraseña actual no es correcta.",
 "srv.password_spaces": "Una contraseña no puede empezar ni terminar con un espacio.",
 "srv.password_too_short": "Use al menos {min} caracteres.",
 "srv.password_unchanged": "Elija una contraseña distinta de la temporal.",
 "srv.pay_link_refused": "No se pudo crear el enlace de pago.",
 "srv.pay_request_closed": "Esta solicitud de pago ya no está abierta.",
 "srv.pay_request_not_found": "No se encontró esa solicitud de pago.",
 "srv.payment_refused": "No se aceptó el pago.",
 "srv.period_closed": "Ese mes está cerrado en contabilidad: la oficina tiene que resolverlo.",
 "srv.print_format_invalid": "Ese formato de impresión no está disponible.",
 "srv.product_unknown_named": "'{product}' no es un producto que vende esta empresa.",
 "srv.proof_kind_invalid": "La prueba debe ser una foto o una firma.",
 "srv.proof_not_image": "La prueba debe ser una imagen.",
 "srv.qty_invalid": "La cantidad debe ser un número entero mayor que cero.",
 "srv.reference_too_long": "Esa referencia es demasiado larga.",
 "srv.route_code_required": "Falta el código de la ruta.",
 "srv.route_not_yours": "Esa ruta no es suya.",
 "srv.pretrip_required": "Envíe la inspección previa al viaje antes de iniciar la ruta.",
 "srv.posttrip_required": "Envíe la inspección posterior al viaje antes de terminar el día.",
 "srv.inspection_day_required": "Abra su ruta de hoy y luego complete la inspección.",
 "srv.inspection_type_invalid": "Elija inspección previa o posterior.",
 "srv.odometer_required": "Ingrese la lectura del odómetro.",
 "srv.odometer_invalid": "Esa lectura del odómetro no parece correcta; revísela.",
 "srv.odometer_below_pre": "El odómetro de la inspección posterior no puede ser menor que el de la inspección previa ({pre} {unit}).",
 "srv.inspection_not_found": "No se encontró ese informe de inspección.",
 "srv.odometer_unit_invalid": "Elija millas o kilómetros para el odómetro.",
 "srv.inspection_answer_required": "Elija “Sin defectos” o indique los defectos que encontró.",
 "srv.inspection_defects_conflict": "Un reporte sin defectos no puede tener defectos.",
 "srv.inspection_defects_required": "Indique los defectos que encontró o elija “Sin defectos”.",
 "srv.inspection_defects_too_many": "Demasiados defectos en un solo reporte.",
 "srv.inspection_section_invalid": "Un defecto indica una parte del vehículo desconocida.",
 "srv.inspection_item_invalid": "Un defecto no está en el formulario de inspección. Actualice la aplicación.",
 "srv.inspection_item_twice": "El mismo elemento aparece dos veces.",
 "srv.inspection_trailer_required": "Ingrese el número del remolque para un defecto del remolque.",
 "srv.inspection_other_note_required": "Describa el defecto que marcó como Otro.",
 "srv.inspection_signature_required": "Firme el reporte.",
 "srv.inspection_signed_off": "La oficina ya aprobó este reporte; ya no se puede cambiar.",
 "srv.inspection_locked": "Este reporte ya está cerrado; avise a la oficina de cualquier novedad.",
 "srv.truck_label_required": "Ingrese el número del camión.",
 "srv.inspection_conflict": "Otro reporte de este día se guardó al mismo tiempo; inténtelo de nuevo.",
 "srv.posttrip_before_start": "Inicie la ruta antes de enviar la inspección posterior al viaje.",
 "srv.pretrip_after_start": "La ruta ya comenzó; ahora no se puede enviar la inspección previa al viaje. Avise a la oficina.",
 "srv.inspection_day_closed": "El día ya terminó; no se puede enviar un reporte de inspección nuevo.",
 "insp.t.air_compressor": "Compresor de aire",
 "insp.t.air_lines": "Líneas de aire",
 "insp.t.axles": "Ejes",
 "insp.t.batteries": "Batería(s)",
 "insp.t.belts_hoses": "Bandas/Mangueras",
 "insp.t.body_frame": "Carrocería/Bastidor",
 "insp.t.brakes_adjustment": "Frenos/Ajuste",
 "insp.t.brakes_service": "Frenos - Sistema de servicio",
 "insp.t.brakes_parking": "Frenos - Sistema de estacionamiento",
 "insp.t.charging_system": "Sistema de carga",
 "insp.t.clutch": "Embrague",
 "insp.t.cooling_system": "Sistema de enfriamiento",
 "insp.t.coupling_devices": "Dispositivos de acoplamiento",
 "insp.t.documents": "Documentos (seguro, permisos, etc.)",
 "insp.t.doors_compartments": "Puertas/Compartimentos",
 "insp.t.drive_lines": "Líneas de transmisión",
 "insp.t.emergency_equipment": "Equipo de emergencia",
 "insp.t.emergency_exits": "Ventanas/Salidas de emergencia",
 "insp.t.engine": "Motor",
 "insp.t.exhaust_system": "Sistema de escape",
 "insp.t.fire_extinguishers": "Extintores",
 "insp.t.first_aid_kit": "Botiquín de primeros auxilios",
 "insp.t.fluid_leaks": "Fugas de líquidos",
 "insp.t.frame": "Chasis",
 "insp.t.fuel_system": "Sistema de combustible",
 "insp.t.heaters_defrosters": "Calefacción/Desempañadores",
 "insp.t.horns": "Bocinas",
 "insp.t.inspection_decal_plates": "Calcomanía de inspección/Placas",
 "insp.t.interior_lights": "Luces interiores",
 "insp.t.lights_reflectors": "Luces/Reflectores",
 "insp.t.load_security_devices": "Dispositivos de sujeción de carga",
 "insp.t.lubrication_systems": "Sistema(s) de lubricación",
 "insp.t.mirrors": "Espejos",
 "insp.t.mud_flaps": "Loderas",
 "insp.t.oil_pressure": "Presión de aceite",
 "insp.t.rear_end": "Diferencial trasero",
 "insp.t.recording_devices": "Dispositivo(s) de registro",
 "insp.t.seats": "Asientos",
 "insp.t.suspension": "Suspensión",
 "insp.t.steering_mechanism": "Mecanismo de dirección",
 "insp.t.transmissions": "Transmisión(es)",
 "insp.t.wheels_tires_studs": "Ruedas/Llantas/Birlos",
 "insp.t.windows_visibility": "Ventanas/Visibilidad",
 "insp.t.wipers_washers": "Limpia/lavaparabrisas",
 "insp.t.other": "Otro",
 "insp.tr.air_lines_glad_hands": "Líneas de aire/Manitas",
 "insp.tr.axles": "Ejes",
 "insp.tr.body_frame": "Carrocería/Bastidor",
 "insp.tr.brakes_adjustment": "Frenos/Ajuste",
 "insp.tr.coupling_devices": "Dispositivos de acoplamiento",
 "insp.tr.coupling_kingpin": "Acoplamiento - Perno rey",
 "insp.tr.doors_compartments": "Puertas/Compartimentos",
 "insp.tr.inspection_decal_plates": "Calcomanía de inspección/Placas",
 "insp.tr.landing_gear": "Patas de apoyo",
 "insp.tr.lights_reflectors": "Luces/Reflectores",
 "insp.tr.load_security_dunnage": "Sujeción de carga/Calzas",
 "insp.tr.mud_flaps": "Loderas",
 "insp.tr.suspension": "Suspensión",
 "insp.tr.wheels_tires_studs": "Ruedas/Llantas/Birlos",
 "insp.tr.other": "Otro",
 "insp.g.brakes_air": "Frenos y aire",
 "insp.g.engine": "Motor y líquidos",
 "insp.g.drivetrain": "Tren motriz",
 "insp.g.electrical": "Eléctrico y luces",
 "insp.g.chassis": "Chasis, ruedas y dirección",
 "insp.g.cab": "Cabina y carrocería",
 "insp.g.safety": "Seguridad y documentos",
 "insp.g.other": "Otro",
 "insp.g.trailer1": "Remolque n.º 1",
 "insp.g.trailer2": "Remolque n.º 2",
 "insp.title.pre": "Inspección previa al viaje",
 "insp.title.post": "Inspección posterior al viaje",
 "insp.required": "Obligatoria en su empresa",
 "insp.optional": "Opcional",
 "insp.close": "Cerrar",
 "insp.truck": "Camión n.º",
 "insp.truckPh": "Número del camión",
 "insp.odo": "Odómetro",
 "insp.odoPh": "Lectura",
 "insp.mi": "Millas",
 "insp.km": "km",
 "insp.q": "¿Qué encontró?",
 "insp.none": "Sin defectos",
 "insp.noneSub": "No detecté ningún defecto ni deficiencia",
 "insp.found": "Encontré defectos",
 "insp.foundSub": "Encontré defectos; elíjalos abajo",
 "insp.search": "Buscar elementos",
 "insp.searchNone": "Sin coincidencias: “{q}”",
 "insp.addTrailer": "Agregar remolque",
 "insp.trailerPh": "Número del remolque",
 "insp.picked": "Defectos: {n}",
 "insp.note": "¿Qué está mal?",
 "insp.photo": "Foto",
 "insp.photoRetake": "Tomar otra",
 "insp.remove": "Quitar",
 "insp.remarks": "Observaciones",
 "insp.remarksPh": "Algo más que la oficina deba saber (opcional)",
 "insp.sign": "Firme aquí",
 "insp.signClear": "Borrar",
 "insp.signedBy": "{name} · {date} · {time}",
 "insp.submit": "Enviar inspección",
 "insp.sending": "Enviando…",
 "insp.need.truck": "Ingrese el número del camión.",
 "insp.need.odo": "Ingrese la lectura del odómetro.",
 "insp.need.answer": "Toque Sin defectos o elija los defectos que encontró.",
 "insp.need.defect": "Elija al menos un defecto.",
 "insp.need.other": "Describa el defecto marcado como Otro.",
 "insp.need.trailer": "Ingrese el número del remolque.",
 "insp.need.sign": "Firme el reporte.",
 "insp.sent": "Inspección enviada a la oficina.",
 "insp.queued": "Guardada en este teléfono; se enviará cuando tenga señal.",
 "insp.notSent": "Inspección no enviada: {why}",
 "insp.storeFailed": "No se pudo guardar la inspección en este teléfono; libere espacio e inténtelo de nuevo.",
 "insp.noRoute": "Primero abra la ruta de hoy.",
 "insp.status.none": "Sin hacer",
 "insp.status.pending": "Esperando para enviar",
 "insp.status.sent": "Enviada {time}",
 "insp.status.clean": "Sin defectos",
 "insp.status.defects": "Defectos reportados: {n}",
 "insp.status.signedOff": "Aprobada por la oficina",
 "insp.do": "Llenar",
 "insp.redo": "Corregir",
 "insp.sendNow": "Enviar ahora",
 "insp.gate.pre": "Envíe la inspección previa al viaje para iniciar la ruta.",
 "insp.gate.post": "Envíe la inspección posterior al viaje para terminar el día.",
 "insp.offerPost": "Haga la inspección posterior al viaje antes de terminar.",
 "insp.skip": "Omitir por ahora",
 "srv.send_channel": "Envíelo por correo o por texto.",
 "srv.send_provider_failed": "El proveedor no lo aceptó.",
 "srv.send_rate_day": "Ya se envió {n} veces hoy.",
 "srv.send_rate_hour": "Ya se envió {n} veces en la última hora: espere antes de enviarlo otra vez.",
 "srv.signin_failed": "No se pudo entrar.",
 "srv.skip_reason_required": "Una parada omitida necesita un motivo.",
 "srv.sms_consent": "Primero pregunte al cliente: para enviarle mensajes de texto a este número se necesita su permiso.",
 "srv.sms_not_set_up": "Los mensajes de texto no están configurados en esta empresa: envíelo por correo.",
 "srv.sms_opted_out": "Ese número pidió no recibir mensajes de texto: envíelo por correo.",
 "srv.stop_already_delivered": "Esta parada ya está entregada: ya no se le puede agregar nada.",
 "srv.stop_not_found": "Esa parada no existe.",
 "srv.stop_status_invalid": "Una parada debe estar hecha, omitida o pendiente.",
 "srv.tender_amount": "Ingrese el monto.",
 "srv.tender_cents": "Los montos van en centavos: como máximo dos decimales.",
 "srv.tender_dup_id": "Dos pagos llevan el mismo identificador.",
 "srv.tender_none": "Ingrese al menos un pago.",
 "srv.tender_too_many": "Son demasiados pagos para un solo cobro.",
 "srv.transfer_lines_required": "Indique qué pasó: un producto y una cantidad mayor que cero.",
 "srv.transfer_refused": "No se aceptó el traspaso.",
 "srv.truck_load_not_counted": "Hoy no se contó la carga del camión #{truck}: confírmela primero.",
 "srv.truck_not_out": "El camión #{truck} no está en ruta hoy.",
 "srv.unknown_product": "Ese no es un producto que vende esta empresa.",
 "srv.unload_none": "Cuente al menos un producto.",
 "srv.unload_refused": "No se aceptó el conteo de descarga.",
 "srv.unpriced_cap": "Este pedido no tiene precios, así que aquí no se puede cobrar más de {cap}: llame a la oficina.",
 "srv.unpriced_cap_held": "Este pedido no tiene precio y ya hay {held} cobrado para él: no se puede cobrar más de {cap} en total hasta que tenga precio. Llame a la oficina.",
 "step.load": "Carga",
 "stop.immovableDone": "{name} ya se entregó",
 "stop.immovableSkipped": "{name} se omitió: ya no está en esta ruta",
 "stop.pinned": "Esa parada está fijada: desbloquéela primero",
 "stop.positionDelivered": "Esa posición ya se entregó: colóquela después de las paradas entregadas",
 "stop.resequenced": "Reordenada: esta parada sigue ahora",
 "stop.routeResequenced": "Ruta {route} reordenada",
 "stop.title": "Parada {n}",
 "sync.b.deliveries": "Entregas",
 "sync.b.loads": "Conteos de carga",
 "sync.b.other": "Otros",
 "sync.b.storage": "Almacenamiento del teléfono",
 "sync.heldOne": "Aún no se guardó: mantenga la app abierta; se guarda cuando haya espacio o señal",
 "sync.heldBanner": {
  "one": "{n} cambio aún no se guardó: mantenga la app abierta; libere espacio o busque señal",
  "other": "{n} cambios aún no se guardaron: mantenga la app abierta; libere espacio o busque señal"
 },
 "dh.stop.notSaved": "Aún no se guardó",
 "sync.b.payments": "Pagos",
 "sync.b.photos": "Fotos y firmas",
 "sync.b.skips": "Omisiones",
 "sync.couldntSendKept": {
  "one": "{n} entrega todavía no se pudo enviar: quedó en este teléfono y se enviará de nuevo",
  "other": "{n} entregas todavía no se pudieron enviar: quedaron en este teléfono y se enviarán de nuevo"
 },
 "sync.couldntSendTold": {
  "one": "{n} entrega no se pudo enviar: ya se avisó a la oficina",
  "other": "{n} entregas no se pudieron enviar: ya se avisó a la oficina"
 },
 "sync.d.lastOk": "Última confirmación de la oficina",
 "sync.d.lastRoute": "Ruta actualizada por última vez",
 "sync.d.nothingWaiting": "No hay nada pendiente en este teléfono.",
 "sync.d.officeTold": "oficina avisada",
 "sync.d.realtime": "Conexión en vivo",
 "sync.d.result": "Sincronizado a las {time}: {sent} enviados, {left} todavía pendientes",
 "sync.d.retryAt": "reintento {time}",
 "sync.d.waitingHd": "Pendiente de enviar",
 "sync.deliveryNotRecorded": "Entrega no registrada: {why}",
 "sync.keptHere": "quedó guardado en este teléfono y se enviará de nuevo",
 "sync.loadNotRecorded": "La carga no quedó registrada en la oficina: {status}",
 "sync.loadSavedHere": "Carga guardada en este teléfono: la oficina la verá en cuanto se pueda",
 "sync.never": "nunca",
 "sync.noOwner": "No se guardó: este teléfono no sabe quién inició sesión. Cierre sesión, vuelva a entrar y repítalo.",
 "sync.noServer": "Esta versión no tiene conexión con la oficina para sincronizar.",
 "sync.storageFull": "Este teléfono no tiene espacio: el trabajo nuevo no se puede guardar sin conexión. Libere espacio y llame a la oficina.",
 "sync.notSaved": "No se guardó: {why}",
 "sync.now": "Sincronizar ahora",
 "sync.officeTold": "ya se avisó a la oficina",
 "sync.offlineWord": "sin conexión",
 "sync.proofFailed": "No se pudo guardar la prueba ({status})",
 "sync.rt.connected": "Conectada",
 "sync.rt.off": "Apagada",
 "sync.rt.polling": "Revisando cada 12 segundos (sin conexión en vivo)",
 "sync.rt.reconnecting": "Reconectando",
 "sync.serverError": "error del servidor",
 "sync.synced": {
  "one": "Se sincronizó {n} acción guardada con la oficina",
  "other": "Se sincronizaron {n} acciones guardadas con la oficina"
 },
 "sync.syncing": "⟳ Sincronizando…",
 "talk.chip.delivered": "Marcar entregada",
 "talk.chip.directions": "Cómo llegar",
 "talk.chip.next": "Próxima parada",
 "talk.chip.skip": "Omitir",
 "talk.close": "Cerrar (Esc)",
 "talk.fabTitle": "Manos libres: “próxima parada”, “cómo llego”, “entregado”, “omitir”",
 "talk.drv.next": "Su próxima parada es {name}{extra}.",
 "talk.drv.allDone": "Terminó: no quedan paradas en esta ruta.",
 "talk.drv.progress": "{done} de {total} paradas hechas, quedan {left}, {money} cobrado en {route}.",
 "talk.drv.collected": "Lleva {money} cobrado hoy en {route}.",
 "talk.drv.noRoute": "Todavía no hay una ruta activa.",
 "talk.drv.limit": "Llegó al límite de Nexus de hoy: hasta mañana responde el propio teléfono.",
 "talk.handsFree": "Manos libres",
 "talk.send": "Enviar",
 "talk.stop": "Parar",
 "talk.stopTitle": "Dejar de hablar (Esc)",
 "talk.sub": "Los comandos de voz todavía se dicen en inglés. Le pregunto antes de cambiar algo.",
 "talk.talk": "Hablar",
 "talk.title": "Manos libres",
 "ticker.checked": "revisado {time}",
 "ticker.watching": "Pendiente de cambios en su ruta",
 "unload.checkAll": "Revise todas las devoluciones",
 "unload.ended": "{truck} turno terminado · devoluciones recibidas",
 "unload.newDay": "Día nuevo a las {time} · semana nueva el domingo a las {time}.",
 "unload.shiftDone": "Turno terminado · {name}",
 "vocab.bags": "bolsas",
 "vocab.bottles": "garrafones",
 "waive.explain": "Esto queda registrado en la parada, para que la oficina vea que se cerró sin firma.",
 "waive.r.declined": "El cliente no quiso firmar",
 "waive.r.door": "Se dejó en la puerta",
 "waive.r.nobody": "No había nadie para firmar",
 "waive.r.pad": "La pantalla de firma no funciona",
 "waive.recorded": "Registrado · {why}",
 "waive.title": "Sin firma: ¿por qué?",
 "xfer.done": "Traspaso: {qty}× {item} — {truck}",
 "xfer.enterBoth": "Ingrese el número del camión y una cantidad",
 "xfer.explainDemo": "Encuéntrese con otro camión (según Despacho) y pase producto: se escanea al salir del suyo y al entrar al otro, y se sincroniza con Despacho.",
 "xfer.explainLive": "El producto sale de su camión y pasa al otro. Despacho lo ve cuando queda registrado.",
 "xfer.product": "Producto",
 "xfer.qty": "Cantidad",
 "xfer.recorded": "{qty}× {item} al #{truck} ({to}): traspaso registrado",
 "xfer.savedHere": "Traspaso guardado en este teléfono: se envía cuando haya señal",
 "xfer.sending": "Enviando {qty}× {item} — #{truck}…",
 "xfer.toTruck": "Al camión",
 "xfer.toTruckNo": "Al camión #",
 "xfer.truckPh": "p. ej. 142",
 "dh.done.invoice": "Factura {n}",
 "dh.noroute.tools": "Mientras espera",
 "dh.off.local": "guardado en este teléfono (demostración, sin oficina)",
 "dh.off.notSaved": "El teléfono no pudo guardar la sesión fuera de ruta — libere espacio en el teléfono.",
 "dh.off.note": "Nota",
 "dh.off.pick": "Primero elija qué está haciendo.",
 "dh.recap.sub": "Solo lectura",
 "dh.recap.prev": "Día anterior",
 "dh.recap.next": "Día siguiente",
 "dh.recap.noFuture": "Un día que aún no ha pasado no tiene resumen.",
 "dh.recap.today": "Hoy · {date}",
 "dh.recap.yesterday": "Ayer · {date}",
 "dh.recap.loading": "Cargando…",
 "dh.recap.failed": "No se pudo cargar ese día. Se cargará cuando vuelva a tener señal.",
 "dh.recap.none": "Ese día no hizo ninguna ruta.",
 "dh.recap.noneWhy": "Un día aparece aquí cuando se ha hecho y cerrado una ruta con este usuario. Use las flechas para ver días anteriores.",
 "dh.recap.route": "Ruta",
 "dh.recap.truck": "Camión",
 "dh.recap.clock": "En turno",
 "dh.recap.done": "paradas hechas",
 "dh.recap.skipped": "omitidas",
 "dh.recap.units": "entregado",
 "dh.recap.collected": "cobrado",
 "dh.recap.stops": "Paradas",
 "dh.recap.only": "solo {what}",
 "dh.recap.delivered": "Entregado: {n}",
 "dh.recap.picked": "Recogido: {n}",
 "dh.recap.planned": "previsto: {n}",
 "dh.recap.noStops": "No hay paradas en esta ruta.",
 "dh.recap.noneOf": "Ninguna ese día.",
 "dh.recap.flags": "Para explicar al regresar",
 "dh.recap.money": "Dinero cobrado",
 "dh.recap.noMoney": "Ese día no se cobró dinero.",
 "dh.recap.equipment": "Equipo / servicio",
 "dh.recap.demo": "Día de muestra: esta versión no tiene historial real de choferes, así que se muestra con datos de demostración.",
 "dh.recap.readOnly": "Solo lectura: un día pasado no se puede cambiar desde el camión. No se muestra la distancia porque no se registra odómetro ni resumen de GPS de un día terminado.",
 "block.holdPayFull": "RETENIDA: entregue solo si paga el total",
 "dh.stop.holdCod": "La oficina dejó a este cliente con la cuenta RETENIDA: entregue solo si paga el total ahora. Llame a su gerente de ruta si tiene dudas",
 "dh.stop.holdWarn": "La oficina dejó a este cliente con la cuenta RETENIDA: consulte con su gerente de ruta antes de entregar",
 "dh.hold.callWho": "Gerente de ruta: {name} {phone}",
 "dh.hold.noManager": "Su empresa no ha indicado un gerente de ruta: llame a la oficina",
 "dh.hold.manager": "gerente de ruta",
 "dh.hold.call": "Llamar a {name}",
 "dh.hold.nowHeld": "La oficina acaba de dejar la cuenta de {name} RETENIDA",
 "dh.start.title": "Primero inicie su día",
 "dh.start.ready": "La inspección del camión y la carga están listas.",
 "dh.start.notReady": "La inspección del camión o la carga no están listas. Puede iniciar sin ellas: indique por qué; la oficina lo verá.",
 "dh.start.why": "¿Por qué inicia sin las revisiones?",
 "dh.start.whyPh": "p. ej., la tableta de inspección no funciona",
 "dh.start.whyNeeded": "Indique por qué (al menos 4 caracteres)",
 "dh.start.without": "Iniciar sin revisiones",
 "dh.start.bypassed": "Inició sin las revisiones: la oficina verá el motivo",
 "dh.eod.closeFirst": {
  "one": "Primero cierre la parada abierta",
  "other": "Primero cierre las {n} paradas abiertas"
 },
 "dh.eod.closeRest": {
  "one": "Cerrar la parada abierta",
  "other": "Cerrar {n} paradas abiertas"
 },
 "dh.eod.closeTitle": {
  "one": "Cerrar la parada abierta",
  "other": "Cerrar {n} paradas abiertas"
 },
 "dh.eod.closeSub": "Cada una se omite con este motivo: la oficina lo verá y la parada pasa al día siguiente.",
 "dh.eod.closed": {
  "one": "{n} parada cerrada",
  "other": "{n} paradas cerradas"
 },
 "dh.eod.doneRefused": "La oficina todavía ve paradas abiertas: actualizando su ruta",
 "contact.noEmail": "No hay correo registrado para {name}",
 "contact.emailing": "Correo a {name} · {email}",
 "dh.stops.email": "Correo",
 "dh.stops.search": "Buscar paradas de hoy",
 "dh.stops.searchPh": "Buscar paradas de hoy: nombre, dirección, pedido",
 "dh.stops.searchNone": "Ninguna parada de la ruta de hoy coincide con «{q}»",
 "dh.info.contact": "Contacto",
 "dh.hist.average": {
  "one": "Promedio de la última entrega: {money}",
  "other": "Promedio de las últimas {n} entregas: {money}"
 },
 "dh.more.invoices": "Facturas de hoy",
 "dh.routing.changedBy": "{who} cambió el orden de sus paradas a las {time}; siguiente: {next}",
 "dh.stops.forNext": "Siguiente parada · {name}",
 "dh.routing.who.monitor": "El agente Monitor",
 "dh.routing.who.nightly": "El plan nocturno",
 "dh.routing.who.dispatcher": "La oficina",
 "dh.routing.who.route-optimizer": "El optimizador de rutas",
 "dh.routing.who.plan": "El plan",
 "dh.routing.who.driver": "Usted",
 "dh.todayinv.title": "Facturas de hoy",
 "dh.todayinv.sub": {
  "one": "{n} factura · {money}",
  "other": "{n} facturas · {money}"
 },
 "dh.todayinv.none": "Todavía no hay facturas en la ruta de hoy",
 "dh.todayinv.paid": "Pagada",
 "dh.todayinv.part": "{money} cobrado",
 "dh.todayinv.open": "Sin pagar",
 "dh.todayinv.needsPrice": "Esperando un precio",
 "dh.todayinv.noAmount": "Sin monto todavía",
 "dh.todayinv.loadFailed": "No se pudieron cargar las facturas de hoy: intente de nuevo con señal",
 "dh.todayinv.docFailed": "No se pudo abrir esa factura: intente de nuevo con señal",
 "dh.inv.title": "Inventario del camión · {truck}",
 "dh.stock.title": "Carga preparada del camión",
 "dh.stock.explain": "El almacén preparó esta carga. Acéptela o marque lo que usted contó.",
 "dh.stock.line": "{n}× {product}",
 "dh.stock.accept": "Aceptar",
 "dh.stock.flag": "Marcar diferencia",
 "dh.stock.itemized": "Cargar artículo por artículo",
 "dh.stock.accepted": "Carga preparada aceptada",
 "dh.stock.flagged": "Su conteo se envió a la oficina",
 "dh.stock.acceptedBanner": "Usted aceptó la carga preparada",
 "dh.stock.flaggedBanner": "Su conteo es la carga — se avisó a la oficina",
 "dh.stock.flagTitle": "Marcar diferencia",
 "dh.stock.flagExplain": "Anote lo que de verdad hay en el camión. La oficina verá cada diferencia.",
 "dh.stock.staged": "Preparado {n}",
 "dh.stock.note": "Nota (opcional)",
 "dh.stock.send": "Enviar conteo",
 "dh.inv.loading": "Cargando el inventario del camión…",
 "dh.inv.unavailable": "No se pudo cargar el inventario del camión. Inténtelo con señal.",
 "dh.inv.balance": "{n} en el camión",
 "dh.inv.sub": "Inicio {start} · vendido {sold}",
 "dh.inv.negative": "Bajo cero: se vendió más de lo cargado. La oficina lo concilia en el andén.",
 "dh.inv.src.verified": "Inventario inicial: la carga que usted revisó.",
 "dh.inv.src.flagged": "Inventario inicial: su conteo.",
 "dh.inv.src.staged": "Inventario inicial: la carga preparada por el almacén (sin su revisión).",
 "dh.inv.src.auto_committed": "Inventario inicial: la carga preparada, registrada cuando el camión salió del patio sin revisión.",
 "dh.inv.src.assumed": "Inventario inicial: supuesto a partir del conteo de fin de día (no es un conteo).",
 "dh.inv.src.zero": "Inventario inicial: cero.",
 "srv.load_check_required": "Su empresa exige revisar la carga del camión antes de vender. Revise la carga primero.",
 "srv.load_check_itemized": "Su empresa revisa la carga artículo por artículo — use Carga.",
 "srv.nothing_staged": "Todavía no se ha preparado nada para este camión.",
 "srv.stock_count_invalid": "Anote cada conteo como número entero, 0 o más.",
 "dh.inv.untiedRow": "Sin producto asignado",
 "dh.inv.untiedSub": "{n} línea(s) de venta · {money}",
 "dh.inv.untiedWarn": "Algunas ventas de hoy no están ligadas a un producto, así que los saldos por producto pueden salir altos. La oficina lo concilia en el andén.",
 "srv.stop_already_recorded": "Esta parada acaba de registrarse con otro envío del teléfono. Revísela antes de enviar de nuevo.",
 "srv.stop_invoiced": "Esta parada ya está entregada y facturada; no se puede reabrir desde el teléfono. Llame a la oficina si hay que cambiarla.",
 "srv.deposit_counts_invalid": "Los conteos de envases no cuadran: revise los envases vacíos entregados y recogidos e inténtelo de nuevo.",
 "dh.inv.balanceUnknown": "no se sabe",
 "dh.inv.soldUnknown": "{n} línea(s) de venta de hoy no están ligadas a un producto, así que no se sabe lo que queda en el camión. La oficina lo concilia en el andén.",
 "srv.stock_count_incomplete": "Cuente todos los productos del camión.",
 "dh.eod.countNote": "Cuente lo que volvió en el camión, producto por producto, y lo dañado. Marque cada producto que contó.",
 "dh.eod.backCol": "Volvió",
 "dh.eod.damagedCol": "Dañado",
 "dh.eod.returned": "{product} que volvió",
 "dh.eod.damaged": "{product} dañado",
 "dh.eod.whyLabel": "Por qué está dañado (si aplica)",
 "dh.eod.whyDamaged": "Diga por qué el producto está dañado antes de terminar.",
 "dh.eod.countSent": "Conteo enviado a la oficina",
 "dh.eod.countQueued": "Conteo guardado en el teléfono — se envía cuando tenga señal",
 "dh.stock.strictBanner": "Revise su carga antes de vender",
 "dh.stock.strictSub": "Su empresa exige revisar primero la carga del camión artículo por artículo.",
 "dh.stock.strictGo": "Revisar la carga",
 "srv.customer_on_hold": "La oficina dejó la cuenta de {name} RETENIDA. No entregue: llame a su gerente de ruta para saber qué hacer. Todavía puede cobrar un pago.",
 "srv.hold_pay_in_full_named": "La oficina dejó la cuenta de {name} RETENIDA: entregue solo si paga el total. Llame a su gerente de ruta.",
 "srv.hold_pay_in_full": "Este cliente tiene la cuenta RETENIDA: entregue solo si paga el total; todavía se deben {money} por esta parada. Llame a su gerente de ruta.",
 "srv.stops_open": "Quedan {n} parada(s) abiertas. Entregue u omita esas paradas antes de terminar.",
 "srv.start_required": "Primero inicie el día (o inicie sin las revisiones, indicando el motivo).",
 "srv.start_reason_required": "Indique por qué inicia sin las revisiones (de 4 a 240 caracteres).",
 "srv.close_stops_required": "Indique qué día y qué paradas cerrar.",
 "srv.not_assigned": "Hoy no tiene ruta.",
 "dh.eod.closeFailed": "No se pudieron cerrar las paradas: no se cambió nada. Intente de nuevo con señal.",
 "dh.eod.officeOpen": {
  "one": "La oficina todavía tiene 1 parada abierta",
  "other": "La oficina todavía tiene {n} paradas abiertas"
 },
 "dh.eod.officeOpenSub": "Ciérrelas con un motivo, o llame a la oficina si las entregó.",
 "dh.routing.orderBy": "Orden de paradas fijado por {who} · {time}",
 "talk.speedN": "Velocidad {n}×",
 "talk.speedTitle": "Qué tan rápido habla Nexus: toque para cambiar",
 "talk.speedSample": "Así de rápido voy a hablar.",
 "talk.engine.title": "Qué voz dijo la última respuesta",
 "talk.engine.neural": "Voz natural",
 "talk.engine.device": "Voz del dispositivo",
 "talk.engine.none": "Sin voz",
 "dh.or.btn": "Fuera de ruta",
 "dh.or.btnHint": "Buscar cliente",
 "dh.or.btnLive": "Fuera de ruta desde las {time}",
 "dh.or.title": "Fuera de ruta",
 "dh.or.scope.route": "Busca en sus rutas asignadas",
 "dh.or.scope.branch": "Busca en el territorio de su sucursal",
 "dh.or.scope.company": "Busca en toda la empresa",
 "dh.or.scope.noHome": "Su empresa limita la búsqueda a su sucursal, pero usted no tiene sucursal asignada — solo se buscan sus propias rutas. Pida a la oficina que la asigne.",
 "dh.or.tabSearch": "Buscar",
 "dh.or.tabNear": "Cerca de mí",
 "dh.or.searchLabel": "Buscar clientes",
 "dh.or.searchPh": "Nombre, nombre comercial, n.º de cuenta o calle",
 "dh.or.typeMore": "Ingrese al menos 2 letras o números.",
 "dh.or.searching": "Buscando…",
 "dh.or.none": "Ningún cliente coincide con “{q}”.",
 "dh.or.capped": "Se muestran los primeros {n} — escriba más para acotar.",
 "dh.or.failed": "La búsqueda no respondió. Inténtelo de nuevo.",
 "dh.or.offline": "Está sin conexión — buscar un cliente necesita señal. No se muestra nada hasta que el teléfono vuelva a tener conexión.",
 "dh.or.demo": "Versión de diseño — clientes de ejemplo, no los de su empresa.",
 "dh.or.status.served": "Atendido hoy",
 "dh.or.status.scheduled": "Programado hoy",
 "dh.or.status.none": "No está en el trabajo de hoy",
 "dh.or.onMine": "En su ruta",
 "dh.or.dba": "Nombre comercial: {name}",
 "dh.or.acct": "Cuenta n.º {n}",
 "dh.or.pastDue": "Vencido {amount}",
 "dh.or.noPin": "Aún no está en el mapa",
 "dh.or.near.locating": "Buscando su ubicación…",
 "dh.or.near.noFix": "No se encuentra su ubicación — active la ubicación para esta aplicación o busque por nombre.",
 "dh.or.near.within": "Dentro de",
 "dh.or.near.radius": "{n} mi",
 "dh.or.near.count": {
  "one": "{n} cliente dentro de {r}",
  "other": "{n} clientes dentro de {r}"
 },
 "dh.or.near.none": "No hay clientes dentro de {r} de usted.",
 "dh.or.near.you": "Usted está aquí",
 "dh.or.near.map": "Mapa de clientes cerca de usted",
 "dh.or.near.legend": "Colores de los marcadores",
 "dh.or.card.loading": "Abriendo la cuenta…",
 "dh.or.card.failed": "La cuenta no se abrió. Inténtelo de nuevo.",
 "dh.or.card.gone": "Esa cuenta no es una que usted pueda consultar.",
 "dh.or.card.holdWhy": "Cuenta retenida — {reason}. Llame a su gerente de ruta antes de atender.",
 "dh.or.card.hold": "Cuenta retenida. Llame a su gerente de ruta antes de atender.",
 "dh.or.card.access": "Acceso al sitio y códigos de portón",
 "dh.or.card.notes": "Notas de la oficina",
 "dh.or.card.visits": "Últimas visitas",
 "dh.or.card.noVisits": "Aún no hay visitas registradas.",
 "dh.or.card.delivered": "Entregó {n}",
 "dh.or.card.call": "Llamar al {phone}",
 "dh.or.card.start": "Iniciar parada fuera de ruta",
 "dh.or.card.startSoon": "Llega en la próxima actualización. Por ahora, avise a la oficina que está aquí y ellos registrarán la entrega.",
 "dh.or.card.here": "Avisar a la oficina que estoy aquí",
 "dh.or.card.told": "Se avisó a la oficina que está fuera de ruta en {name}.",
 "dh.or.card.queued": "Sin señal — se avisará a la oficina cuando el teléfono vuelva a tener conexión.",
 "dh.or.card.refused": "No se pudo avisar a la oficina: {why}",
 "dh.or.card.local": "Versión de diseño — se guarda en este teléfono, no se envía.",
 "dh.or.declare": "Decirle a la oficina qué está haciendo (motivo y notas)",
 "dh.or.logRow": "Anotar lo que hizo",
 "dh.or.endRow": "Terminar fuera de ruta",
 "dh.or.reasonStop": "Parada fuera de ruta",
 "dh.more.offroute": "Fuera de ruta — buscar cliente",
 "talk.drv.orFind": "Buscando <b>{q}</b> para ir fuera de ruta.",
 "talk.drv.orNear": "Abriendo los clientes cerca de usted.",
 "talk.chip.orNear": "Fuera de ruta cerca",
 "srv.not_in_scope": "Esa cuenta no es una que usted pueda consultar.",
 "srv.offroute_location_invalid": "No se reconoce esa cuenta.",
 "srv.query_too_short": "Ingrese al menos 2 letras o números.",
 "srv.position_invalid": "No llegó su ubicación — inténtelo de nuevo cuando el teléfono tenga señal GPS.",
 "dh.or.skipped": "Omitida hoy",
 "dh.or.badge": "FUERA DE RUTA",
 "dh.or.start.starting": "Iniciando la parada fuera de ruta…",
 "dh.or.start.offline": "Está sin conexión — iniciar una parada fuera de ruta necesita señal. No se envió nada.",
 "dh.or.start.failed": "No se inició la parada: {why}",
 "dh.or.start.notYet": "Iniciada — aparecerá en sus paradas en un momento.",
 "dh.or.revisit.title": "Ya atendido hoy",
 "dh.or.revisit.sub": "{name} ya fue atendido hoy. ¿Cómo se factura esta visita?",
 "dh.or.revisit.standalone": "Factura nueva",
 "dh.or.revisit.child": "Agregar a la factura de hoy",
 "dh.or.far.title": "¿No está en el cliente?",
 "dh.or.far.sub": "Está a {dist} de {name}. ¿Iniciar la parada fuera de ruta de todos modos?",
 "dh.or.far.anyway": "Iniciar de todos modos",
 "dh.ci.chip": "Especial",
 "dh.ci.plainDigits": "Use solo dígitos 0–9 en el nombre.",
 "dh.ci.badChars": "Un nombre no puede tener < ni >.",
 "dh.ci.notInvoicedTitle": "No facturado",
 "dh.ci.notInvoiced": "Los productos especiales están desactivados: {items} no se facturó.",
 "dh.ci.giveBack": "Devuelva {money} al cliente.",
 "dh.ci.gaveBack": "Devolví {money}",
 "dh.ci.keepCredit": "Pedir a la oficina que lo deje como crédito",
 "dh.ci.nothingTaken": "No se cobró nada por eso.",
 "dh.ci.refundTold": "La oficina sabe que devolvió {money}",
 "dh.ci.creditTold": "La oficina sabe que debe dejarlo como crédito",
 "dh.ci.open": "Producto especial",
 "dh.ci.remove": "Quitar",
 "dh.ci.title": "Producto especial",
 "dh.ci.sub": "Algo que no está en el catálogo: la oficina lo revisa",
 "dh.ci.name": "Nombre",
 "dh.ci.namePh": "¿Qué es?",
 "dh.ci.qty": "Cantidad",
 "dh.ci.price": "Precio unitario",
 "dh.ci.lineTotal": "Total de la línea",
 "dh.ci.add": "Agregar",
 "dh.ci.needName": "Ingrese un nombre.",
 "dh.ci.nameLong": "Máximo 80 caracteres en el nombre.",
 "dh.ci.noCard": "Parece un número de tarjeta: nunca escriba datos de tarjeta aquí.",
 "dh.ci.badQty": "Cantidad: un número entero de 1 a 999.",
 "dh.ci.needPrice": "Ingrese el precio unitario.",
 "dh.ci.badPrice": "Precio unitario: de 0 a 10,000, en centavos.",
 "dh.ci.added": "{item} agregado · {money}",
 "dh.ci.removed": "{item} quitado",
 "dh.ci.alreadySent": "Ya se envió a la oficina: llame a la oficina para cambiarlo.",
 "dh.ap.open": "Agregar producto",
 "dh.ap.title": "Agregar producto",
 "dh.ap.sub": "Busque en el catálogo por nombre o SKU",
 "dh.ap.search": "Buscar",
 "dh.ap.searchPh": "Nombre o SKU",
 "dh.ap.none": "Ningún producto coincide.",
 "dh.ap.done": "Listo",
 "dh.ap.more": "Se muestran {n} de {of}: ingrese más letras para acotar",
 "sync.customRefused": "No se agregó: {item}: {why}. Se avisó a la oficina.",
 "dh.ap.empty": "Nada agregado todavía: use Agregar producto o Producto especial.",
 "dh.ud.title": "¿Agregar estos a los productos habituales de {name}?",
 "dh.ud.sub": "Marque lo que debe recibir la próxima vez. Esta entrega no cambia.",
 "dh.ud.sold": "{n} vendidos hoy",
 "dh.ud.add": "Agregar marcados",
 "dh.ud.skip": "Omitir",
 "dh.ud.none": "Marque un producto o toque Omitir.",
 "dh.ud.done": "Productos habituales actualizados ({n})",
 "dh.ud.queued": "Guardado en este teléfono: se enviará",
 "srv.custom_items_off": "Su empresa no permite productos especiales: elija un producto del camión o llame a la oficina.",
 "srv.custom_item_invalid": "Ese producto especial no es válido: revise el nombre, la cantidad y el precio.",
 "srv.add_defaults_off": "Su empresa no permite que los choferes cambien los productos habituales de un cliente.",
 "srv.defaults_invalid": "Elija hasta 50 productos, cada uno con una cantidad creíble.",
 "srv.defaults_order_stop": "Los productos de esta parada vienen de su pedido: la oficina fija sus productos habituales.",
 "dh.fill.tax": "Impuesto {rate}%",
 "dh.or.pay.photo": "Foto del cheque",
 "dh.or.pay.photoDone": "Foto del cheque guardada",
 "dh.or.pay.photoQueued": "Foto del cheque guardada en el teléfono — se envía al volver la conexión.",
 "dh.or.pay.photoSlow": "La oficina no respondió a tiempo. La foto del cheque queda en el teléfono y se envía sola — toque Sincronizar ahora para enviarla otra vez.",
 "dh.or.pay.needPhoto": "Primero tome una foto del cheque.",
 "dh.or.voiceStartAsk": "¿Iniciar una parada fuera de ruta en <b>{name}</b>?",
 "dh.or.demoStart": "Versión de diseño — la parada se agrega solo a la ruta de ejemplo de este teléfono.",
 "dh.or.cancel.btn": "Cancelar parada",
 "dh.or.cancel.title": "¿Cancelar esta parada fuera de ruta?",
 "dh.or.cancel.sub": "No se entregó nada en {name}. La parada sale de su día y no pasa a mañana. La oficina ve que usted la canceló.",
 "dh.or.cancel.yes": "Cancelar la parada",
 "dh.or.cancel.keep": "Mantener la parada",
 "dh.or.cancel.done": "Parada fuera de ruta en {name} cancelada",
 "dh.or.cancel.queued": "Parada fuera de ruta en {name} cancelada en este teléfono — se envía a la oficina cuando tenga señal",
 "dh.stock.countTitle": "Cuente su camión",
 "dh.stock.countSub": "Su empresa revisa la carga antes de vender. Cuente lo que hay en el camión ahora, artículo por artículo — ponga 0 en lo que no tenga.",
 "dh.stock.countSend": "Enviar el conteo",
 "dh.stock.countLater": "Más tarde",
 "dh.stock.counted": "Carga contada — ya puede vender",
 "dh.or.truck.title": "¿En qué camión está?",
 "dh.or.truck.sub": "No tiene un camión propio registrado. Elija el camión que maneja — las ventas fuera de ruta de hoy salen de su inventario.",
 "dh.or.truck.pick": "Camión {number} · {type}",
 "srv.client_id_mismatch": "Ese inicio ya se usó para otra cuenta. Inicie la parada de nuevo.",
 "srv.truck_choice_required": "Primero elija el camión que maneja.",
 "srv.offroute_stop_served": "Esta parada ya se atendió — no se puede cancelar.",
 "srv.check_photo_required": "Primero tome una foto de cada cheque o giro postal.",
 "srv.truck_invalid": "Ese camión no es de su empresa.",
 "srv.truck_in_use": "Ese camión hace hoy la ruta de otro chofer — elija otro.",
 "srv.truck_mismatch": "Las paradas fuera de ruta de hoy ya están en otro camión.",
 "srv.load_count_one_tap": "Su empresa acepta la carga preparada con un toque — use Aceptar o Marcar diferencia.",
 "dh.nudge.region": "Avisos para seguir adelante",
 "dh.nudge.linger.title": "Hora de seguir",
 "dh.nudge.linger": "Hora de ir a {next} — ≈ {min} min de manejo, la ventana cierra {time}",
 "dh.nudge.lingerNoWin": "Hora de ir a {next} — ≈ {min} min de manejo",
 "dh.nudge.risk.title": "Ventana en riesgo",
 "dh.nudge.risk": "{next} — la ventana cierra {time}, ≈ {min} min de manejo. Salga ahora para llegar a tiempo.",
 "dh.nudge.long.title": "Parada larga",
 "dh.nudge.long": "Sigue en {name} — ¿terminar la parada?",
 "dh.nudge.left.title": "Parada sin terminar",
 "dh.nudge.left": "Salió de {name} sin terminar la parada",
 "dh.nudge.go": "Ir",
 "dh.nudge.open": "Abrir",
 "dh.nudge.skip": "Omitir",
 "dh.nudge.snooze": "Posponer {min} min",
 "dh.nudge.at": "a las {time}",
 "dh.nudge.at1": "a la {time}",
 "dh.nudge.more": "Ver el mensaje completo",
 "dh.nudge.dismiss": "Descartar",
 "pw.confirm": "Confirme la contraseña nueva",
 "pw.done": "Contraseña guardada: ya entró.",
 "pw.mismatch": "Las dos contraseñas no coinciden.",
 "pw.new": "Contraseña nueva",
 "pw.noReach": "No se pudo comunicar con la oficina. Su contraseña no cambió: inténtelo de nuevo.",
 "pw.save": "Guardar contraseña",
 "pw.saving": "Guardando…",
 "pw.spaces": "Una contraseña no puede empezar ni terminar con un espacio.",
 "pw.title": "Cree una contraseña nueva",
 "pw.tooShort": "Use al menos {min} caracteres.",
 "pw.why": "Entró con una contraseña temporal. Elija la suya para continuar: al menos {min} caracteres.",
 "dh.nav.label": "Principal",
 "dh.nav.today": "Hoy",
 "dh.nav.stops": "Paradas",
 "dh.nav.map": "Mapa",
 "dh.nav.truck": "Camión",
 "dh.nav.more": "Más",
 "dh.d.skippedAt": "Omitida {time}",
 "dh.d.aSkipped": "omitida",
 "dh.d.doneIn": "Entregada {time} · a tiempo",
 "dh.d.doneLate": "Entregada {time} · fuera de horario",
 "dh.d.doneAt": "Entregada {time}",
 "dh.d.aDoneIn": "entregada a tiempo",
 "dh.d.aDoneLate": "entregada fuera de su horario",
 "dh.d.aOpen": "sin horario",
 "dh.d.missed": "Perdida · cerró {time}",
 "dh.d.aMissed": "horario perdido",
 "dh.d.atRisk": "En riesgo · antes de {time}",
 "dh.d.aRisk": "en riesgo",
 "dh.d.closes": "Cierre {time}",
 "dh.d.aSoon": "el horario cierra pronto",
 "dh.d.aTimed": "con horario",
 "dh.d.order": "Pedido {n}",
 "dh.d.onHold": "Retenido",
 "dh.d.openRecord": "{name} — ver lo registrado",
 "dh.d.later": "DESPUÉS",
 "dh.d.nextAria": "Próxima parada",
 "dh.d.nextPill": "PRÓXIMA PARADA",
 "dh.d.nextPillN": "PRÓXIMA PARADA · {n} de {of}",
 "dh.d.openStop": "Abrir parada",
 "dh.d.arrive": "Llega {time}",
 "dh.d.aStop": "Parada {n}, {state}",
 "dh.d.aOffDone": "Parada fuera de ruta, hecha",
 "dh.d.view": "Vista",
 "dh.d.offN": "+{n} fuera de ruta",
 "dh.d.tools": "Herramientas de paradas",
 "dh.d.search": "Buscar paradas",
 "dh.d.filter": "Filtrar paradas",
 "dh.d.leg.info": "{n} con horario",
 "dh.d.leg.warn": "{n} justas",
 "dh.d.leg.bad": "{n} en riesgo",
 "dh.d.leg.ok": "{n} hechas",
 "dh.d.g.pre": "Inspección previa",
 "dh.d.g.load": "Carga",
 "dh.d.g.route": "Ruta",
 "dh.d.g.now": "Ahora",
 "dh.d.g.onRoute": "En ruta",
 "dh.d.g.locked": "Bloqueada",
 "dh.d.g.about": "~{time}",
 "dh.d.firstOpens": "Apertura del primer horario",
 "dh.d.estFinish": "Fin estimado",
 "dh.d.stopsToday": {
  "one": "parada hoy",
  "other": "paradas hoy"
 },
 "dh.d.overview": "Resumen del día",
 "dh.d.preNote": "Su ruta se desbloquea después de la inspección previa — su empresa la exige todos los días.",
 "dh.d.toLoad": "Para cargar · plan",
 "dh.d.greet.morning": "Buenos días, {name}",
 "dh.d.greet.afternoon": "Buenas tardes, {name}",
 "dh.d.greet.evening": "Buenas noches, {name}",
 "dh.d.greetNone.morning": "Buenos días",
 "dh.d.greetNone.afternoon": "Buenas tardes",
 "dh.d.greetNone.evening": "Buenas noches",
 "dh.d.truckN": "Camión {n}",
 "dh.ps.remove": "Quitar {name}",
 "dh.ps.short": "{n} de {of} — el resto vuelve a la oficina",
 "dh.ps.less": "Uno menos de {name}",
 "dh.ps.more": "Uno más de {name}",
 "dh.ps.fromTruck": "Del camión",
 "dh.ps.custom": "Especial",
 "dh.ps.empty": "Nada en esta parada todavía — agrega del camión.",
 "dh.ps.removed": "{item} quitado de esta parada",
 "dh.ps.deliver": "Entregar",
 "dh.ps.meta": {
  "one": "{n} producto · {items}",
  "other": "{n} productos · {items}"
 },
 "dh.ps.totalDue": "Total a cobrar",
 "dh.ps.deliverCollect": "Entregar y cobrar",
 "dh.ps.takePhoto": "Tomar foto de entrega",
 "dh.ft.title": "Agregar del camión",
 "dh.ft.countsNow": "los números son lo que hay a bordo ahora",
 "dh.ft.countsUnknown": "aún no se sabe lo que hay en el camión",
 "dh.ft.onTruck": "{n} en el camión",
 "dh.ft.left": "quedan {n}",
 "dh.ft.none": "No hay en el camión",
 "dh.ft.tileAria": "{name}, {n} en esta parada — toque para agregar uno",
 "dh.ft.each": "{money} c/u",
 "dh.ft.done": "Listo · {n} en la parada {seq} · {money}",
 "dh.ci.addTo": "Agregar a la parada {seq}",
 "dh.ci.addToMoney": "Agregar a la parada {seq} · {money}",
 "dh.cust.title": "Cliente",
 "dh.ci.officeNote": "Nota de la oficina sobre este pedido",
 "dh.ci.accountNotes": "Notas de la cuenta",
 "dh.ci.termsChip": "Términos {terms}",
 "dh.ci.text": "Mensaje",
 "dh.ci.balance": "Saldo pendiente",
 "dh.ci.pastDue": "{money} vencido",
 "dh.ci.credit": "Crédito a favor",
 "dh.ci.asOf": "a las {time}",
 "dh.ci.emailQueued": "Guardado en este teléfono — se envía a la oficina para revisión cuando haya señal",
 "dh.ci.emailLocal": "Guardado en este teléfono (demostración — sin oficina aquí)",
 "dh.ci.emailSaved": "Guardado — marcado para que la oficina lo confirme",
 "dh.ci.addEmailFor": "Agregar un correo para {name}",
 "dh.ci.addEmailPh": "Agregar su correo",
 "dh.ci.save": "Guardar",
 "dh.ci.account": "Cuenta {n}",
 "dh.ci.loading": "Obteniendo la cuenta de la oficina…",
 "dh.ci.cardOffline": "No se puede contactar a la oficina — se muestra lo que tiene este teléfono.",
 "dh.ci.acct": "Cuenta",
 "dh.ci.holdWhy": "Retenido:",
 "dh.ci.contacts": "Contactos",
 "dh.ci.delivery": "Entrega",
 "dh.ci.recent": "Entregas recientes",
 "dh.ci.allHistory": "Ver todo el historial",
 "dh.ci.openNotes": {
  "one": "Abrir la nota",
  "other": "Abrir {n} notas"
 },
 "dh.ci.emailBad": "Ese correo no parece correcto — revísalo y guarda otra vez.",
 "dh.pay.checkPhoto": "Foto del cheque",
 "dh.pay.recordOnAcct": "Registrar {money} a cuenta",
 "dh.pay.recordAmt": "Registrar {money} en {method}",
 "dh.pay.recordTitle": "Registrar pago",
 "dh.pay.modeLabel": "Tipo de pago",
 "dh.pay.withDelivery": "Con entrega",
 "dh.pay.payOnlyMode": "Solo pago",
 "dh.pay.onAccount": "Cobro a cuenta · sin entrega",
 "dh.pay.cardSafeT": "Lo procesa su proveedor de pagos",
 "dh.pay.cardSafe": "Los números de tarjeta nunca se guardan en este teléfono ni con nosotros — la factura guarda solo los últimos 4.",
 "dh.pay.charge": "Cobrar",
 "dh.pay.owed": "Adeudado",
 "dh.pay.amountDue": "Monto a cobrar",
 "dh.pay.cashReceived": "Efectivo recibido",
 "dh.pay.overTitle": "Pagó {money} de más → crédito del cliente",
 "dh.pay.overSub": "El crédito del cliente queda en {money}",
 "dh.pay.nowPart": "{money} ahora",
 "dh.pay.staysPart": "{money} queda a cuenta",
 "dh.pay.whyPartial": "¿Por qué parcial?",
 "dh.pay.reason.short": "Le falta efectivo",
 "dh.pay.reason.dispute": "Disputa el monto",
 "dh.pay.reason.mail": "Enviará cheque",
 "dh.pay.reason.other": "Otro",
 "dh.pay.shortNote": "Faltan {money} — quedan a cuenta",
 "dh.pay.creditOnFile": "Crédito a favor {money}",
 "dh.pay.creditApplied": "{money} de crédito aplicado",
 "dh.pay.tender": "Forma de pago",
 "dh.pay.keypad": "Teclado",
 "display.layout.deck": "Panel",
 "dh.look.hint.deck": "Predeterminado · nuevo",
 "dh.d.collectedToday": "Cobrado hoy",
 "dh.stops.todo": "Por hacer",
 "dh.stops.segAria": "Paradas",
 "dh.d.skippedMark": "Omitida",
 "dh.nav.noRoute": "Sin ruta",
 "dh.nav.noRouteWhy": "Hoy no hay ruta",
 "dh.truck.title": "Camión {n}",
 "dh.truck.yours": "Suyo hoy",
 "dh.truck.onBoard": "A bordo ahora",
 "dh.truck.itemsLeft": "Quedan {n}",
 "dh.truck.loaded": "Cargado",
 "dh.truck.sold": "Vendido",
 "dh.truck.left": "Queda",
 "dh.truck.noCounts": "Todavía no se ha contado nada en este camión.",
 "dh.truck.reports": "Inspecciones del camión",
 "dh.truck.reportDone": "Terminada a las {time}",
 "dh.truck.reportView": "Ver informe",
 "dh.truck.reportNone": "Todavía no se hace",
 "dh.truck.odo": "Odómetro",
 "dh.truck.result": "Resultado",
 "dh.truck.signoff": "Visto bueno de la oficina",
 "dh.truck.signed": "Aprobada",
 "dh.truck.notSigned": "Todavía no",
 "dh.truck.reportNote": "Solo lectura. Se envió a la oficina cuando la terminó.",
 "dh.truck.moreInv": "Inventario completo del camión",
 "dh.alerts.title": "Alertas",
 "dh.alerts.bell": "Alertas",
 "dh.alerts.bellAria": "Alertas, {n} sin leer",
 "dh.alerts.new": "{n} nuevas",
 "dh.alerts.markRead": "Marcar todo como leído",
 "dh.alerts.none": "No hay alertas. Cuando la oficina cambie su ruta, o algo necesite su atención, aparecerá aquí.",
 "dh.num.range": "Ingrese un número de {min} a {max}.",
 "srv.email_invalid": "Ese correo no parece correcto.",
 "srv.email_exists": "Este cliente ya tiene un correo: la oficina lo cambia.",
 "srv.location_gone": "Ya no existe el lugar de esa parada.",
 "b2.insp.pre": "Inspección previa",
 "b2.insp.post": "Inspección posterior",
 "b2.insp.sub": "Informe de inspección del viaje · {date}",
 "b2.insp.required": "Obligatorio",
 "b2.insp.truckWord": "Camión",
 "b2.insp.unit": "Unidad inspeccionada",
 "b2.insp.tTruck": "Camión",
 "b2.insp.groups": "Partes del camión",
 "b2.insp.all": "Todos {n}",
 "b2.insp.find": "O busque un defecto · {n} elementos",
 "b2.insp.trailerNo": "Número del {which}",
 "b2.insp.addPhoto": "Agregar una foto del defecto",
 "b2.insp.noneBtn": "Sin defectos · todo bien",
 "b2.insp.noneOn": "Sin defectos · seleccionado",
 "b2.insp.noneBlocked": "Quite los defectos marcados para elegir esto",
 "b2.insp.remarksPh": "Observaciones (opcional)",
 "b2.insp.signed": "Firmado · {name}",
 "b2.insp.odoLow": "Debe ser al menos la lectura de la inspección previa, {pre} {unit}",
 "b2.insp.preFlagged": "En la inspección previa se marcó {items}; la oficina ya lo sabe.",
 "b2.insp.submitPre": "Enviar inspección previa",
 "b2.insp.submitPost": "Enviar inspección posterior",
 "b2.insp.nDefects": {"one": "{n} defecto", "other": "{n} defectos"},
 "b2.insp.gs.brakes_air": "Frenos",
 "b2.insp.gs.engine": "Motor",
 "b2.insp.gs.drivetrain": "Transmisión",
 "b2.insp.gs.electrical": "Luces",
 "b2.insp.gs.chassis": "Ruedas",
 "b2.insp.gs.cab": "Cabina",
 "b2.insp.gs.safety": "Seguridad",
 "b2.insp.gs.other": "Otro",
 "b2.truck.ticked": "Elementos reportados",
 "b2.in.hero": "¿Listo para salir?",
 "b2.in.sub": "Inicie sesión con el correo o el ID de chofer que le dio la oficina.",
 "b2.in.show": "Mostrar contraseña",
 "b2.in.hide": "Ocultar contraseña",
 "b2.pw.hero": "Hágala suya",
 "b2.pw.step": "Paso 2 de 3",
 "b2.pw.weak": "Débil",
 "b2.pw.fair": "Regular",
 "b2.pw.good": "Buena",
 "b2.pw.strong": "Fuerte",
 "b2.pw.strengthAria": "Seguridad: {word}",
 "b2.pw.ruleLen": "Al menos {min} caracteres",
 "b2.pw.ruleNum": "Incluye un número",
 "b2.pw.ruleSame": "Las dos coinciden",
 "b2.pw.save": "Guardar y continuar",
 "b2.load.accepted": "Todo cargado como se preparó.",
 "b2.load.confirmed": "Carga confirmada. Inicie la ruta desde Hoy.",
 "b2.load.acceptAll": "Aceptar todo como se preparó",
 "b2.load.itemByItem": "Cargar artículo por artículo",
 "b2.load.confirm": "Confirmar carga · {n} artículos",
 "b2.load.planned": "Planeado {n}",
 "b2.load.notPlanned": "No está en el plan",
 "b2.load.short": "faltan {n}",
 "b2.load.extra": "{n} de más",
 "b2.load.ofLoaded": "/ {n} cargados",
 "b2.load.ofItems": "de {n} artículos cargados",
 "b2.load.st.loading": "Cargando",
 "b2.load.st.loaded": "Cargado",
 "b2.load.st.locked": "Bloqueado",
 "b2.load.hintOpen": "Acepte todo como se preparó, o ajuste cada producto abajo.",
 "b2.load.match": "{a} de {b} productos coinciden con el plan",
 "b2.load.toGo": "faltan {n}",
 "b2.load.lockStarted": "Bloqueado: la ruta empezó a las {time}, así que la carga ya no cambia.",
 "b2.load.lockNote": "Se bloquea (solo lectura) cuando empieza la ruta.",
 "b2.eod.sRoute": "Ruta",
 "b2.eod.sUnload": "Descarga",
 "b2.eod.sPost": "Después",
 "b2.eod.sDone": "Listo",
 "b2.eod.productsLabel": "Productos",
 "b2.eod.loadedCol": "Cargado",
 "b2.eod.damagedCol": "Dañado",
 "b2.eod.leftCol": "En el camión",
 "b2.eod.formula": "Entregado + dañado + en el camión = cargado.",
 "b2.eod.loadedLine": "Cargado {n}",
 "b2.eod.expect": "deberían quedar {n}",
 "b2.eod.tickRow": "{name}: lo que queda en el camión es lo esperado",
 "b2.eod.unShort": "{n} sin explicar",
 "b2.eod.unOver": "{n} más de lo cargado",
 "b2.eod.allExpected": "Todo como se esperaba",
 "b2.eod.counted": "{a} de {b} contados",
 "b2.eod.countAll": "Cuente primero los productos: ingrese cada uno o toque su círculo si es lo esperado.",
 "b2.eod.nextPost": "Siguiente: inspección final (obligatoria)",
 "b2.eod.tillLabel": "Efectivo y cheques",
 "b2.eod.cashCounted": "Efectivo contado",
 "b2.eod.checksCounted": "Cheques contados",
 "b2.eod.recorded": "Registrado {amount}",
 "b2.eod.recordedWait": "Registrado: cargando",
 "b2.eod.recordedChecks": "Registrados {n} · {amount}",
 "b2.eod.matches": "Coincide",
 "b2.eod.shortBy": "Faltan {amount}",
 "b2.eod.overBy": "Sobran {amount}",
 "b2.eod.checksMissing": {"one":"Falta {n} cheque. Búsquelo:","other":"Faltan {n} cheques. Búsquelos:"},
 "b2.eod.checksExtra": {"one":"{n} cheque más de los registrados","other":"{n} cheques más de los registrados"},
 "b2.eod.unloadTitle": "Cuente el camión",
 "b2.map.onRoute": "En ruta",
 "b2.map.onSchedule": "Al día",
 "b2.map.behind": "Con retraso",
 "b2.map.allClosed": "Todas las paradas cerradas",
 "b2.map.finish": "termina a eso de las {time}",
 "b2.map.arrive": "llega",
 "b2.map.distance": "desde aquí",
 "b2.map.mi": "{n} mi",
 "b2.map.recenter": "Centrar el mapa",
 "b2.map.noNext": "No hay una próxima parada.",
 "b2.map.you": "Este camión",
 "b2.skip.stop": "Parada {n}",
 "b2.skip.why": "¿Por qué la omite?",
 "b2.skip.sub": "Elija uno y confirme. La parada vuelve a la oficina como omitida y la oficina lo ve de inmediato.",
 "b2.skip.note": "Nota (opcional)",
 "b2.skip.photo": "Agregar una foto",
 "b2.skip.stay": "{n} artículos se quedan en el camión. Aún puede volver a la parada {stop} hoy.",
 "b2.skip.pickFirst": "Elija un motivo",
 "b2.skip.confirm": "Omitir parada {n} · {reason}",
 "b2.notes.title": "Notas",
 "b2.notes.sub": "Notas con la oficina · Parada {n}",
 "b2.notes.office": "Oficina",
 "b2.notes.you": "Usted",
 "b2.notes.q.onway": "Voy en camino",
 "b2.notes.q.late": "10 min de retraso",
 "b2.notes.q.thanks": "Gracias",
 "b2.notes.q.callme": "Llámeme",
 "b2.notes.ph": "Ingrese una nota para la oficina",
 "b2.notes.send": "Enviar nota",
 "b2.notes.photo": "Adjuntar una foto",
 "b2.notes.saved": "Enviada",
 "b2.notes.pending": "Guardada en este teléfono",
 "b2.notes.oneWay": "La oficina lee su nota en esta parada. Las respuestas de la oficina aún no están en la app.",
 "b2.notes.sentToast": "Nota enviada a la oficina.",
 "b2.notes.phoneOnly": "Guardada en este teléfono (sin conexión con la oficina).",
 "b2.inv.paid": "Entregado y pagado",
 "b2.inv.delivered": "Entregado",
 "b2.inv.inWindow": "dentro de la ventana",
 "b2.inv.number": "Factura {n}",
 "b2.inv.pending": "Factura (el número llega después)",
 "b2.inv.paidVia": "Pagado · {method}",
 "b2.inv.credit": "Pago de más → crédito del cliente",
 "b2.inv.sendReceipt": "Enviar recibo",
 "b2.inv.noEmail": "Aún no hay correo: agregue uno para enviar",
 "b2.inv.send": "Enviar",
 "b2.inv.alsoSaved": "También se guarda en la cuenta · la oficina lo confirmará",
 "b2.inv.keptNoSend": "Correo guardado para la oficina. Por ahora imprima el recibo.",
 "b2.inv.keptWaiting": "Correo guardado. El recibo sale cuando la entrega llegue a la oficina.",
 "b2.inv.afterWindow": "fuera de la ventana",
 "b2.inv.total": "Total",
 "b2.inv.invoice": "Factura",
 "b2.off.acct": "Cuenta {n}",
 "b2.off.count": {"one":"{n} cuenta","other":"{n} cuentas"},
 "b2.more.profile": "Perfil",
 "b2.more.appearance": "Apariencia",
 "b2.more.colour": "Tema de color",
 "b2.more.help": "Ayuda y contactar a la oficina",
 "b2.more.light": "Claro",
 "b2.more.dark": "Oscuro",
 "b2.al.riskTitle": "Parada {n} en riesgo",
 "b2.al.t.all": "Todas",
 "b2.al.t.office": "Oficina",
 "b2.al.t.route": "Ruta",
 "b2.al.t.risk": "En riesgo",
 "b2.al.type": "Tipo de alerta",
 "b2.al.unread": "Sin leer",
 "b2.al.ok": "Entendido",
 "b2.al.review": "Revisar el nuevo orden",
 "b2.rv.title": "Repaso del día",
 "b2.rv.sub": "Repaso del día · {route} · Camión {truck}",
 "b2.rv.summary": "Resumen del día",
 "b2.rv.doneOf": "hechas de {n}",
 "b2.rv.offRoute": "fuera de ruta",
 "b2.rv.collected": "Cobrado · efectivo + cheques + tarjetas",
 "b2.rv.skipped": "Omitida {time}",
 "b2.rv.after": "{n} min después de la ventana",
 "b2.rv.inWindow": "dentro de la ventana",
 "b2.rv.a.ok": "Parada {n}, entregada dentro de la ventana",
 "b2.rv.a.late": "Parada {n}, atendida después de la ventana",
 "b2.rv.a.skip": "Parada {n}, omitida",
 "b2.rv.a.none": "Parada {n}",
 "b2.rv.segAria": "Paradas: {done} hechas, {skipped} omitidas, {off} fuera de ruta",
 "b2.skip.pickWhy": "Elija por qué omite esta parada.",
 "b2.eod.atLeast": "al menos {n}",
 "b2.eod.loadedUnknown": "Hoy no hay una carga medida para este camión (no se preparó ni se contó nada), así que no se puede calcular lo que debería quedar. Cuente lo que hay en el camión.",
 "b2.off.since": "desde las {time}",
 "srv.password_no_digit": "Incluya al menos un número en su contraseña.",
 "insp.truckPick": "Elija un camión",
 "insp.truckFailed": "No se pudieron cargar los camiones de la empresa.",
 "insp.truckLoading": "Cargando los camiones de la empresa…",
 "insp.truckNone": "La empresa no tiene camiones registrados. Pida a la oficina que agregue el suyo.",
 "xfer.truckPick": "Elija un camión",
 "xfer.truckNone": "Hoy ningún otro camión está en ruta.",
 "xfer.trucksFailed": "No se pudieron cargar los camiones en ruta hoy. Intente de nuevo con señal.",
 "dh.start.elsewhere": "Esta ruta se inició en otro dispositivo.",
 "srv.truck_unknown": "El camión {truck} no es de la empresa. Elija uno de la lista.",
 "srv.load_locked_started": "La ruta ya inició, así que la carga ya no se puede cambiar.",
 "srv.truck_maintenance": "Ese camión está en mantenimiento — elija otro.",
 "srv.truck_loading": "Ese camión se está cargando — elija otro.",
 "dh.or.truck.filter": "Ingrese el número del camión",
 "srv.crew_not_found": "Ese chofer o camión no está registrado.",
 "insp.need.truckPick": "Elija el camión.",
 "dh.pay.creditAvail": "Crédito disponible {money}",
 "dh.pay.creditApplyLabel": "Aplicar crédito",
 "dh.pay.creditApplyHint": "Descuenta {money} de lo que se debe",
 "dh.pay.creditStays": "No hay nada por cobrar: el crédito sigue en la cuenta",
 "dh.pay.creditAutoNote": "La empresa aplica el crédito automáticamente",
 "dh.pay.creditUnknown": "El saldo de crédito no se conoce sin conexión: la oficina lo resuelve",
 "dh.pay.overAdded": "Se sumó al saldo de crédito del cliente · crédito nuevo {money}",
 "dh.pay.overAddedNew": "Se sumó al saldo de crédito del cliente",
 "dh.done.creditNew": "El crédito del cliente ahora es {money}",
 "dh.stop.creditAvail": "{money} de crédito en esta cuenta: aplíquelo al registrar el pago",
 "dh.pay.creditRulesUnknown": "La regla de crédito de la empresa aún no se conoce: la oficina ajusta el crédito al sincronizar",
 "b2.notes.twoWay": "Sus notas van a la oficina. Las respuestas aparecen aquí.",
 "dh.msg.sending": "Enviando…",
 "dh.msg.seen": "Vista",
 "dh.msg.loading": "Leyendo las notas…",
 "dh.msg.offline": "Sin conexión: se muestran las notas guardadas en este teléfono.",
 "dh.msg.unread": {"one":"{n} nuevo de la oficina","other":"{n} nuevos de la oficina"},
 "dh.msg.alert": {"one":"{name}: la oficina respondió","other":"{name}: la oficina escribió {n} notas nuevas"},
 "dh.msg.openNotes": "Abrir las notas",
 "alert.kind.msg": "Nota de la oficina",
 "srv.message_empty": "Ingrese un mensaje primero.",
 "srv.message_too_long": "Ese mensaje es muy largo.",
 "p5.truck.returned": "Devuelto",
 "p5.truck.reload": "Recargar camión",
 "p5.truck.pending": "{n} recarga esperando para enviarse.",
 "p5.truck.retNote": "Las unidades devueltas siguen en el camión; no se cuentan como disponibles para vender.",
 "p5.rl.title": "Recargar camión",
 "p5.rl.sub": "¿Volviste al almacén por más? Agrega lo que cargaste.",
 "p5.rl.sum": "{n} unidades por agregar",
 "p5.rl.none": "Agrega una cantidad a al menos un producto",
 "p5.rl.send": "Confirmar recarga",
 "p5.rl.done": "Recarga registrada",
 "p5.rl.queued": "Guardado en este teléfono. Se enviará cuando tengas conexión.",
 "p5.rl.empty": "No hay productos para elegir.",
 "p5.rt.btn": "Devolución del cliente",
 "p5.rt.title": "Devolución del cliente · {name}",
 "p5.rt.sub": "Producto que el cliente devuelve. Si está en buen estado vuelve a la venta; vencido o dañado se queda en el camión, sin vender.",
 "p5.rt.product": "Producto",
 "p5.rt.qty": "Cantidad",
 "p5.rt.why": "¿Por qué?",
 "p5.rt.why.good": "En buen estado — se vende",
 "p5.rt.why.stale": "Vencido",
 "p5.rt.why.damaged": "Dañado",
 "p5.rt.why.other": "Otro motivo",
 "p5.rt.send": "Registrar devolución",
 "p5.rt.needProduct": "Elige un producto",
 "p5.rt.needQty": "Agrega una cantidad",
 "p5.rt.needWhy": "Di por qué lo devolvieron",
 "p5.rt.done": "Devolución registrada",
 "p5.rt.queued": "Guardado en este teléfono. Se enviará cuando tengas conexión.",
 "p5.rt.list": "Devuelto por el cliente",
 "p5.rt.row": "{n} · {why}",
 "p5.rt.pending": "esperando para enviarse",
 "p5.eod.cust": "Clientes devolvieron {n}",
 "p5.inv.sub": "Cargado {loaded} · Entregado {sold} · Devuelto {ret}",
 "srv.reload_invalid": "Elige productos reales y cantidades enteras de 1 o más.",
 "srv.return_invalid": "Elige un producto, una cantidad de 1 o más y por qué lo devolvieron.",
 "svc.badge": "SERVICIO",
 "svc.title": "Llamada de servicio",
 "svc.timeRecording": "Se está registrando el tiempo",
 "svc.timeRecorded": "Tiempo registrado: {min} min",
 "svc.account": "Cuenta",
 "svc.site": "Lugar",
 "svc.job": "El trabajo",
 "svc.est": "unos {min} min",
 "svc.equipment": "Equipo",
 "svc.expected": "En la orden: {tag}",
 "svc.tagUnknown": "No se conoce la identificación del equipo; escanéela o escríbala.",
 "svc.tagPh": "Identificación del equipo",
 "svc.scan": "Escanear etiqueta",
 "svc.scanNone": "No se leyó ninguna etiqueta en esa foto; escriba la identificación.",
 "svc.photos": "Fotos",
 "svc.photoBefore": "Foto de antes",
 "svc.photoAfter": "Foto de después",
 "svc.parts": "Piezas cambiadas",
 "svc.noParts": "No se agregaron piezas.",
 "svc.addPart": "Agregar una pieza…",
 "svc.add": "Agregar",
 "svc.qty": "Cantidad",
 "svc.remove": "Quitar",
 "svc.noCatalogue": "La empresa aún no tiene lista de piezas; escriba las piezas en las notas.",
 "svc.notes": "Notas",
 "svc.speak": "Dictar notas",
 "svc.listening": "Escuchando…",
 "svc.fixedInvoice": "Reparado: completar y cobrar al cliente",
 "svc.fixedSummary": "Reparado: completar (factura sin cargo)",
 "svc.cantFix": "No se puede reparar: completar y agregar un cambio",
 "svc.invoiceCompany": "Reparado: facturar a la empresa",
 "svc.cantFixInvoice": "No se puede reparar: facturar a la empresa y pedir un cambio",
 "svc.closedFixed": "Reparado: este servicio está cerrado.",
 "svc.closedCant": "No se pudo reparar: este servicio está cerrado.",
 "svc.back": "Volver a las paradas",
 "svc.billSent": "Su factura a la empresa: {amount}.",
 "svc.invoiced": "Se creó la factura {number}.",
 "svc.exchangeAdded": "Se agregó una orden de cambio para la oficina.",
 "svc.queued": "Guardado en este teléfono; se envía cuando haya señal.",
 "svc.invoicedNoCharge": "Se creó la factura {number}, sin cargo.",
 "scan.title": "Escanear un código",
 "scan.close": "Cerrar",
 "scan.starting": "Encendiendo la cámara…",
 "scan.aim": "Apunte la cámara al código",
 "scan.noCamera": "No hay cámara. Escriba el código abajo.",
 "scan.cameraRefused": "La cámara no tiene permiso. Escriba el código abajo.",
 "scan.loadingReader": "Preparando el lector de códigos…",
 "scan.noReader": "Este teléfono no puede leer códigos con la cámara. Escriba el código abajo.",
 "scan.typeLabel": "O escriba el código",
 "scan.typePh": "Por ejemplo PLT-4K7Q2M8",
 "scan.lookUp": "Buscar",
 "dock.kicker": "Andén",
 "dock.title": "Camiones y equipos",
 "dock.lead": "Escanee una etiqueta o un rótulo, busque un equipo o prepare la carga de una ruta.",
 "dock.scan": "Escanear",
 "dock.scanSub": "Una etiqueta de tarima o el rótulo de un equipo",
 "dock.equipment": "Equipos",
 "dock.equipmentSub": "Busque un equipo y vea su historial",
 "dock.routes": "Rutas de hoy",
 "dock.routesSub": "Prepare la carga de cada ruta",
 "dock.back": "Atrás",
 "dock.signOut": "Cerrar sesión",
 "dock.leave": "Salir del modo andén",
 "dock.reading": "Leyendo…",
 "dock.noReach": "No se pudo contactar a la oficina. Intente de nuevo.",
 "dock.noRoutes": "Hoy no hay rutas.",
 "dock.ready": "Lista",
 "dock.itemsN": {"one": "{n} artículo en la carga", "other": "{n} artículos en la carga"},
 "dock.notStarted": "Sin empezar",
 "dock.truck": "Camión {n}",
 "dock.noTruck": "Sin camión todavía",
 "dock.noDriver": "Sin chofer todavía",
 "dock.stopsN": {"one": "{n} parada", "other": "{n} paradas"},
 "dock.productUnknown": "Producto sin nombre",
 "dock.unitsNoProduct": {"one": "{n} unidad sin producto indicado", "other": "{n} unidades sin producto indicado"},
 "dock.noProducts": "No hay productos en los pedidos",
 "dock.routeTitle": "Ruta {code}",
 "dock.prepare": "Preparar carga",
 "dock.buildPallet": "Armar una tarima nueva",
 "dock.scanPallet": "Escanear una tarima armada",
 "dock.scanTag": "Escanear el rótulo de un equipo",
 "dock.onLoad": {"one": "En la carga · {n} artículo", "other": "En la carga · {n} artículos"},
 "dock.nothingYet": "Todavía no hay nada en esta carga.",
 "dock.readyWhy": "Primero agregue una tarima o un equipo.",
 "dock.markReady": "Marcar carga lista",
 "dock.readyBy": "Carga lista · {name} · {time}",
 "dock.pallet": "Tarima",
 "dock.equipmentOne": "Equipo",
 "dock.empty": "Vacía",
 "dock.typed": "Escrito a mano",
 "dock.typedReason": "Escrito a mano en el andén",
 "dock.scanned": "Escaneado",
 "dock.remove": "Quitar",
 "dock.added": "{code} está en la carga",
 "dock.buildTitle": "Armar una tarima",
 "dock.buildLead": "Elija cada producto y cuántos, y luego escanee la etiqueta que pegó en la tarima.",
 "dock.product": "Producto",
 "dock.chooseProduct": "Elija un producto",
 "dock.count": "Cuántos",
 "dock.addProduct": "Agregar un producto",
 "dock.unitsOnPallet": {"one": "{n} unidad en la tarima", "other": "{n} unidades en la tarima"},
 "dock.scanLabelToAttach": "Escanear la etiqueta de la tarima",
 "dock.draftWhy": "Elija un producto y una cantidad entera de 1 o más en cada línea.",
 "dock.eqSearch": "Rótulo o tipo",
 "dock.find": "Buscar",
 "dock.scanTagLook": "Escanear un rótulo para buscarlo",
 "dock.noEquipment": "Ningún equipo coincide.",
 "dock.atWarehouse": "En el almacén {code}",
 "dock.atCustomer": "Con un cliente",
 "dock.placeUnknown": "Lugar no registrado",
 "dock.openMove": "En traslado · ruta {route}",
 "dock.alsoScans": "También se escanea como {tags}",
 "dock.history": "Historial",
 "dock.noHistory": "No hay historial registrado.",
 "dock.forRoute": "para la ruta {code}",
 "dock.h.scan": "Escaneado",
 "dock.h.picked": "Recogido",
 "dock.h.delivered": "Entregado",
 "dock.h.requested": "Traslado pedido",
 "dock.h.scheduled": "Traslado programado",
 "dock.h.closed": "Traslado cerrado",
 "dock.h.exception": "Excepción",
 "dock.voidLabel": "Esta etiqueta fue reemplazada. Use {code}.",
 "dock.notRead": "No se buscó.",
 "dock.pst.blank": "En blanco",
 "dock.pst.built": "Armada",
 "dock.pst.assigned": "En una ruta",
 "dock.pst.loaded": "Cargada",
 "dock.pst.partial": "Cargada en parte",
 "dock.pst.void": "Reemplazada",
 "dock.badCheck": "Parece un código de tarima pero el último carácter no coincide. Revise la etiqueta.",
 "dock.notOnFile": "Ninguna tarima ni equipo tiene este código.",
 "dock.notOnFileHelp": "Un rótulo nuevo o de fábrica se asigna a su equipo en la oficina: Equipos, Escanear un código.",
 "dock.scanAnother": "Escanear otro",
 "ls.open": "Escanear la carga",
 "ls.kicker": "Carga",
 "ls.title": "Escanear la carga · {code}",
 "ls.offline": "copia del teléfono, sin señal",
 "ls.none": "No se preparó una carga en el andén para esta ruta. Cargue como siempre.",
 "ls.progress": "{done} de {n} en el camión",
 "ls.scan": "Escanear",
 "ls.allOn": "Todo está en el camión.",
 "ls.startNow": "Iniciar ruta",
 "ls.startAnyway": "Iniciar de todos modos (se avisa a la oficina)",
 "ls.gateTitle": {"one": "Falta {n} artículo en el camión", "other": "Faltan {n} artículos en el camión"},
 "ls.gateStrict": "Su empresa revisa la carga antes de iniciar la ruta. Escanee cada artículo o confírmelo a mano con un motivo.",
 "ls.gateSoft": "Escanee cada artículo o inicie de todos modos y se avisará a la oficina.",
 "ls.st.open": "Todavía no está en el camión",
 "ls.st.loaded": "En el camión",
 "ls.st.manual": "En el camión · confirmado a mano",
 "ls.st.partial": "Incompleta · en el camión",
 "ls.count": "Anotar cantidades",
 "ls.byHand": "¿No escanea? Confirmar a mano",
 "ls.countTitle": "Lo que subió al camión",
 "ls.countLead": "Cuente cada producto al subirlo. Más que la tarima está bien.",
 "ls.onPallet": "{n} en la tarima",
 "ls.confirmOn": "Confirmar en el camión",
 "ls.cancel": "Cancelar",
 "ls.why": "¿Por qué?",
 "ls.note": "En sus palabras",
 "ls.r.label": "Etiqueta dañada o ilegible",
 "ls.r.tag": "Falta el rótulo",
 "ls.r.scanner": "La cámara o el escáner no funciona",
 "ls.r.other": "Otro",
 "ls.manualTitle": "Confirmar a mano",
 "ls.manualLead": "Solo si el código no se escanea. La oficina ve el motivo.",
 "ls.manualGo": "Confirmar que está en el camión",
 "ls.manualWhy": "Primero elija el motivo.",
 "ls.manualNote": "Diga qué pasó (unas palabras).",
 "ls.shortWhy": "Menos de lo que lleva la tarima: diga por qué.",
 "ls.countWhole": "\"{v}\" no es una cantidad. Use un número entero, 0 o más.",
 "ls.palletOn": "{code} está en el camión",
 "ls.tagOn": "{tag} está en el camión",
 "ls.byHandDone": "Confirmado a mano",
 "ls.queued": "Guardado en el teléfono. Se envía cuando haya señal.",
 "ls.notRead": "No se pudo leer la lista de carga.",
 "ls.notSaved": "No se guardó. Intente de nuevo.",
 "ls.void": "Esta etiqueta fue reemplazada. Escanee {code}.",
 "srv.load_items_open": {"one": "Falta {n} artículo en el camión. Escanéelo o confírmelo a mano con un motivo.", "other": "Faltan {n} artículos en el camión. Escanéelos o confírmelos a mano con un motivo."},
 "srv.not_on_load": "Ese código no está en la carga de este camión.",
 "srv.pallet_void": "Esa etiqueta fue reemplazada. Escanee {code}.",
 "srv.short_reason_required": "Menos de lo que lleva la tarima: diga por qué.",
 "srv.manual_reason_required": "Elija por qué lo confirma a mano.",
 "srv.manual_note_required": "Diga qué pasó (unas palabras).",
 "srv.scan_empty": "Escanee o escriba un código.",
 "srv.not_a_pallet": "Solo una tarima tiene cantidades que confirmar.",
 "se.primary": {"one": "Equipo: escanee {n} unidad", "other": "Equipo: escanee {n} unidades"},
 "se.kicker": "Equipo en esta parada",
 "se.left": {"one": "Falta escanear {n} unidad", "other": "Faltan escanear {n} unidades"},
 "se.allDone": "Todas las unidades están listas. Puede terminar la parada.",
 "se.scan": "Escanear un rótulo",
 "se.none": "No hay equipo para esta parada hoy.",
 "se.back": "Volver a la parada",
 "se.handOver": "Entregar",
 "se.takeBack": "Recoger",
 "se.waiting": "Todavía sin escanear",
 "se.skip": "¿No escanea? Omitir con un motivo",
 "se.skipTitle": "Omitir {tag}",
 "se.skipLead": "Solo si el rótulo no se escanea. La oficina ve el motivo.",
 "se.skipGo": "Omitirlo",
 "se.skipped": "Omitido",
 "se.notOnTruck": "{tag} no está en este camión",
 "se.notOnTruckLead": "Entréguelo solo si está seguro. Diga por qué; la oficina lo ve.",
 "se.handAnyway": "Entregarlo de todos modos",
 "se.handed": "Entregado",
 "se.tookBack": "Recogido · regresa en el camión",
 "se.depositOut": "{type}: uno más entregado, ya anotado en la pantalla de depósitos",
 "se.notRead": "No se pudo leer el equipo de la parada.",
 "srv.not_on_truck": "{tag} no está en este camión. Diga por qué lo entrega.",
 "srv.equipment_scan_required": "Primero escanee el equipo: {tags} (u omítalo con un motivo).",
 "srv.stop_no_location": "Esta parada no tiene la ubicación del cliente.",
 "srv.equipment_unknown": "Ese rótulo no está registrado.",
 "ls.st.handed": "Entregado en una parada",
 "ls.st.returning": "Regresa en el camión",
 "se.depositIn": "{type}: uno más devuelto, ya anotado en la pantalla de depósitos",
 "se.depositLater": "(anótelo en la pantalla de depósitos de la parada)",
 "dep.outLabel": "Entregados",
 "ls.st.unloaded": "Descargado en el almacén",
 "wh.section": "Almacén",
 "wh.unload": "Descargar devoluciones",
 "wh.unloadSub": "Equipos que regresan en un camión",
 "wh.holding": "Área de espera",
 "wh.holdingSub": "Equipos que esperan servicio",
 "wh.unloadLead": "Elija la ruta en la que regresó el camión.",
 "wh.noReturns": "Ningún equipo regresa en un camión.",
 "wh.nOfM": "{n} de {m} devueltos",
 "wh.nOfMReturned": "{n} de {m} devueltos",
 "wh.unloadRoute": "Descargar la ruta {code}",
 "wh.scanUnit": "Escanear un equipo",
 "wh.expected": "Regresan en este camión",
 "wh.noneOnRoute": "Ningún equipo regresa en esta ruta.",
 "wh.onTruck": "Todavía en el camión",
 "wh.condAsk": "¿En qué estado está {tag}?",
 "wh.cond.good": "Bueno",
 "wh.cond.needs_cleaning": "Necesita limpieza",
 "wh.cond.damaged": "Dañado",
 "wh.cancel": "Cancelar",
 "wh.already": "{tag} ya se había descargado.",
 "wh.intoHolding": "{tag} está en el área de espera ({cond}).",
 "wh.holdingLead": "Equipos que esperan servicio o desecho.",
 "wh.holdingEmpty": "No hay nada en el área de espera.",
 "wh.holdingN": "{n} en espera",
 "wh.atWh": "en {code}",
 "wh.heldSince": "En espera desde {when}",
 "wh.cameBack": "Regresó: {cond}",
 "wh.ticketOpen": "Orden {code} · {fault}",
 "wh.ticketCnf": "Orden {code} · {fault} · no se pudo reparar en el sitio",
 "wh.noTicket": "Sin iniciar",
 "wh.inService": "En servicio",
 "srv.equipment_held": "{tag} está en el área de espera para servicio. Termine el servicio antes de que salga.",
 "srv.equipment_scrapped": "{tag} se desechó. No puede volver a salir.",
 "wh.startService": "Iniciar servicio",
 "wh.startServiceSub": "Escanee un equipo en espera para trabajar en él",
 "wh.openService": "Abrir su servicio",
 "wh.scanToService": "Escanee el equipo a reparar",
 "wh.finishStock": "Terminar – regresa al inventario",
 "wh.serviceTitle": "Servicio de {tag}",
 "wh.timerSince": "Cronómetro en marcha desde {time}",
 "wh.ticketN": "Orden {code}",
 "wh.fault": "Falla: {fault}",
 "wh.noFault": "Sin falla registrada",
 "wh.yourNote": "Nota: {note}",
 "wh.parts": "Piezas",
 "wh.noPartsYet": "Todavía sin piezas.",
 "wh.partLine": "{qty} instaladas · {cost}",
 "wh.costs": "Piezas {parts} · Mano de obra: {labour}",
 "wh.noRate": "sin tarifa registrada",
 "wh.rate": "{rate} por hora",
 "wh.photosN": "{n} fotos",
 "wh.addPart": "Agregar pieza",
 "wh.pickPart": "Elija la pieza que instaló",
 "wh.noParts": "La empresa aún no tiene lista de piezas.",
 "wh.addNote": "Agregar nota",
 "wh.saveNote": "Guardar nota",
 "wh.noteSaved": "Nota guardada.",
 "wh.photo": "Foto",
 "wh.photoBefore": "Foto de antes guardada.",
 "wh.photoAfter": "Foto de después guardada.",
 "wh.scrap": "Desechar",
 "wh.scrapAsk": "¿Desechar {tag}?",
 "wh.scrapWhy": "Se da de baja y nunca podrá cargarse ni colocarse de nuevo.",
 "wh.scrapYes": "Sí, desecharlo",
 "wh.backInStock": "{tag} regresó al inventario.",
 "wh.wasScrapped": "{tag} se desechó.",
 "wh.took": "El servicio tomó {n} min.",
 "wh.backToHolding": "Volver al área de espera",
 "wh.recv": "Recibir nuevos",
 "wh.recvSub": "Un lote nuevo del camión",
 "wh.recvLead": "Cada equipo nuevo recibe un rótulo. Escriba un rango de rótulos o escanee cada uno.",
 "wh.type": "Tipo de equipo",
 "wh.warehouse": "Almacén",
 "wh.chooseWh": "Elija un almacén",
 "wh.how": "Cómo se ingresan los rótulos",
 "wh.modeRange": "Un rango de rótulos",
 "wh.modeScan": "Escanear cada rótulo",
 "wh.prefix": "Prefijo del rótulo (por ejemplo XYZ-)",
 "wh.from": "Primer número",
 "wh.to": "Último número",
 "wh.scanTag": "Escanear un rótulo",
 "wh.noTagsYet": "Todavía no hay rótulos escaneados.",
 "wh.goesTo": "A dónde va el lote",
 "wh.toAvailable": "Directo a Disponible",
 "wh.toInspect": "Área de espera para inspección",
 "wh.receive": "Recibir el lote",
 "wh.received": "{n} recibidos",
 "wh.intoAvailable": "Están disponibles.",
 "wh.intoInspect": "Esperan en el área de espera para inspección.",
 "wh.skippedN": "{n} omitidos:"
}
